{
  "common": {
    "loading": "Laddar...",
    "loadingLabel": "Laddar",
    "readOnlyHint": "Klicka på 'Redigera {{entity}}' under Åtgärder för att låsa upp fält. Vissa fält kan inte ändras efter skapande.",
    "unsavedChangesTitle": "Kasta osparade ändringar?",
    "unsavedChangesDescription": "Du har osparade ändringar. Om du fortsätter försvinner dina ändringar.",
    "keepEditing": "Fortsätt redigera",
    "discardChanges": "Kasta ändringar",
    "switchLanguage": "Byt språk",
    "save": "Spara",
    "cancel": "Avbryt",
    "delete": "Ta bort",
    "edit": "Redigera",
    "create": "Skapa",
    "search": "Sök",
    "filter": "Filtrera",
    "actions": "Åtgärder",
    "confirm": "Bekräfta",
    "back": "Tillbaka",
    "next": "Nästa",
    "submit": "Skicka",
    "close": "Stäng",
    "yes": "Ja",
    "no": "Nej",
    "error": "Fel",
    "success": "Lyckades",
    "minutes": "min",
    "warning": "Varning",
    "info": "Info",
    "all": "Alla",
    "view": "Visa",
    "add": "Lägg till",
    "update": "Uppdatera",
    "remove": "Ta bort",
    "status": "Status",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "blacklisted": "Svartlistad",
    "pending": "Väntande",
    "completed": "Slutförd",
    "current": "Nuvarande",
    "upcoming": "Kommande",
    "name": "Namn",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "more": "mer",
    "description": "Beskrivning",
    "image": "Bild",
    "noImage": "Ingen bild",
    "createdAt": "Skapad",
    "updatedAt": "Uppdaterad",
    "email": "E-post",
    "phone": "Telefon",
    "viewMode": {
      "tabs": "Kort",
      "list": "Lista"
    },
    "weekDaysShort": ["Mån", "Tis", "Ons", "Tors", "Fre", "Lör", "Sön"],
    "currency": "Valuta",
    "select": "Välj",
    "loadMore": "Ladda fler",
    "cost": "Kostnad",
    "date": "Datum",
    "notes": "Anteckningar",
    "saving": "Sparar...",
    "retry": "Försök igen",
    "type": "Typ",
    "quickActions": "Snabbåtgärder",
    "deleted": "Borttagen",
    "confirmDelete": "Bekräfta borttagning",
    "confirmDeleteDescription": "Denna åtgärd kan inte ångras. Är du säker på att du vill ta bort objektet?",
    "details": "Detaljer",
    "download": "Ladda ned",
    "dragToReorder": "Dra för att ändra ordning",
    "export": "Exportera",
    "notFound": "Hittades inte.",
    "print": "Skriv ut",
    "appName": "Care of Cars",
    "saved": "Sparades",
    "scrollLeft": "Scrolla vänster",
    "scrollRight": "Scrolla höger",
    "today": "Idag",
    "previous": "Föregående",
    "previousMonth": "Föregående månad",
    "nextMonth": "Nästa månad",
    "previousWeek": "Föregående vecka",
    "nextWeek": "Nästa vecka",
    "clear": "Rensa",
    "moreOptions": "Fler alternativ",
    "help": "Hjälp",
    "decrease": "Minska",
    "searchEmployee": "Sök anställd...",
    "required": "Obligatoriskt",
    "regNumberPlaceholder": "ABC 123",
    "type": "Typ",
    "failed": "Misslyckades",
    "weekDays": {
      "monday": "Måndag",
      "tuesday": "Tisdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lördag",
      "sunday": "Söndag"
    }
  },
  "admin": {
    "confirmDeleteUser": "Ta bort {{name}}? Detta kan inte ångras.",
    "confirmDeleteRole": "Ta bort {{name}}? Detta kan inte ångras.",
    "confirmDeleteOrg": "Ta bort {{name}}? Detta kan inte ångras.",
    "confirmDeleteSalesCompany": "Ta bort {{name}}? Detta kan inte ångras.",
    "confirmDeletePlan": "Ta bort planen {{name}}? Detta kan inte ångras."
  },
  "nav": {
    "dashboard": "Översikt",
    "scheduler": "Schemaläggare",
    "booking": "Bokning",
    "newBooking": "Ny bokning",
    "customers": "Kunder",
    "vehicles": "Fordon",
    "services": "Tjänster",
    "jobs": "Jobb",
    "pricing": "Priser",
    "roles": "Roller & Behörigheter",
    "settings": "Inställningar",
    "account": "Konto",
    "changePassword": "Ändra lösenord",
    "home": "Hem",
    "mainMenu": "Huvudmeny",
    "system": "System",
    "mainNavigation": "Huvudnavigering",
    "homeAriaLabel": "Care of Cars - Hem",
    "primaryNavigation": "Primär navigering",
    "openMenu": "Öppna meny",
    "expandSidebar": "Expandera sidopanel",
    "collapseSidebar": "Minimera sidopanel",
    "userMenu": "Användarmeny",
    "leaves": "Ledighet",
    "workLogs": "Arbetstid",
    "billing": "Fakturering",
    "products": "Produkter",
    "rentalFleet": "Hyresflotta",
    "campaigns": "Kampanjer",
    "communication": "Kommunikation",
    "categories": "Kategorier",
    "integrations": "Integrationer",
    "hrSection": "HR",
    "businessSection": "Verksamhet",
    "loanCars": "L?nebilar",
    "myWork": "Min arbetsyta",
    "myWorkspace": "Min arbetsyta",
    "teamOverview": "Tidrapportgodkännanden",
    "economy": "Ekonomi",
    "reviews": "Recensioner"
  },
  "auth": {
    "login": "Logga in",
    "logout": "Logga ut",
    "register": "Registrera",
    "signIn": "Logga in",
    "signUp": "Registrera dig",
    "signOut": "Logga ut",
    "email": "E-post",
    "password": "Lösenord",
    "confirmPassword": "Bekräfta lösenord",
    "forgotPassword": "Glömt lösenord?",
    "forgotPasswordLink": "Gå till glömt lösenord-sidan",
    "resetPassword": "Återställ lösenord",
    "rememberMe": "Kom ihåg mig i 30 dagar",
    "rememberMeHint": "Håll mig inloggad i 30 dagar",
    "noAccount": "Har du inget konto?",
    "hasAccount": "Har du redan ett konto?",
    "createAccount": "Skapa konto",
    "createAccountLink": "Gå till registreringssidan",
    "requestAccessMessage": "Åtkomst ges endast via inbjudan. Kontakta din administratör.",
    "welcome": "Välkommen",
    "enterCredentials": "Ange dina uppgifter för att komma åt ditt konto",
    "name": "Namn",
    "fullName": "Fullständigt namn",
    "loginForm": "Inloggningsformulär",
    "loginFailed": "Inloggning misslyckades. Kontrollera dina uppgifter.",
    "noRoleAssigned": "Ditt konto har ingen roll tilldelad i denna organisation ännu, så menyåtkomst kan inte laddas. Kontakta din administratör.",
    "showPassword": "Visa lösenord",
    "hidePassword": "Dölj lösenord",
    "passwordToggleHint": "Växla lösenordssynlighet",
    "emailHint": "Ange din e-postadress",
    "emailPlaceholder": "du@exempel.se",
    "brandingSection": "Varumärkesinformation",
    "manageBusinessTitle": "Hantera din bilserviceverksamhet",
    "manageBusinessDesc": "Effektivisera verksamheten, spåra jobb, hantera kunder och växa ditt företag med vår heltäckande lösning.",
    "forgotPasswordTitle": "Glömt lösenordet?",
    "forgotPasswordDesc": "Ingen fara, vi skickar återställningsinstruktioner till dig.",
    "sendResetLink": "Skicka återställningslänk",
    "checkYourEmail": "Kontrollera din e-post",
    "resetLinkSentDesc": "Vi har skickat en länk för återställning av lösenord till",
    "resendEmail": "Fick du inget e-postmeddelande? Skicka igen",
    "backToLogin": "Tillbaka till inloggning",
    "setNewPassword": "Ange nytt lösenord",
    "setNewPasswordDesc": "Ditt nya lösenord måste skilja sig från tidigare använda lösenord.",
    "newPassword": "Nytt lösenord",
    "passwordMinLength": "Måste vara minst 8 tecken",
    "resetPasswordButton": "Återställ lösenord",
    "passwordResetSuccess": "Lösenordet har återställts",
    "passwordResetSuccessDesc": "Ditt lösenord har återställts. Du kan nu logga in med ditt nya lösenord.",
    "continueToLogin": "Fortsätt till inloggning"
  },
  "org": {
    "switchOrganization": "Byt organisation",
    "selectOrganization": "Välj organisation",
    "organizations": "Organisationer",
    "organization": "Organisation",
    "selectOrgDescription": "Välj vilken organisation du vill arbeta med"
  },
  "store": {
    "stores": "Butiker",
    "mainStore": "Huvudbutik",
    "primary": "Primär",
    "noStores": "Inga butiker tillgängliga"
  },
  "notifications": {
    "title": "Notifikationer",
    "viewAll": "Visa alla notifikationer",
    "noNotifications": "Inga notifikationer",
    "newJobAssigned": "Nytt jobb tilldelat",
    "upcomingAppointment": "Påminnelse om kommande bokning",
    "scheduleChange": "Schemat har uppdaterats",
    "paymentReceived": "Kundbetalning mottagen",
    "serviceCompleted": "Fordonsservice slutförd"
  },
  "user": {
    "profile": "Profil",
    "myAccount": "Mitt konto",
    "settings": "Inställningar",
    "language": "Språk"
  },
  "accountPage": {
    "tabs": {
      "profile": "Profil",
      "security": "Säkerhet",
      "notifications": "Notifieringar",
      "sessions": "Sessioner",
      "loginHistory": "Inloggningshistorik"
    },
    "profile": {
      "picture": {
        "title": "Profilbild",
        "description": "Uppdatera din profilbild",
        "upload": "Ladda upp bild",
        "hint": "JPG, GIF eller PNG. Maxstorlek 2 MB."
      },
      "personal": {
        "title": "Personlig information",
        "description": "Uppdatera dina personliga uppgifter",
        "firstName": "Förnamn",
        "lastName": "Efternamn",
        "email": "E-postadress",
        "phone": "Telefonnummer",
        "company": "Företagsnamn"
      },
      "address": {
        "title": "Adress",
        "description": "Din företags- eller personliga adress",
        "street": "Gatuadress",
        "city": "Stad",
        "state": "Region",
        "zip": "Postnummer"
      },
      "actions": {
        "save": "Spara ändringar"
      }
    },
    "security": {
      "requirements": {
        "minLength": "Minst 8 tecken",
        "uppercase": "Innehåller stor bokstav",
        "lowercase": "Innehåller liten bokstav",
        "number": "Innehåller en siffra",
        "specialCharacter": "Innehåller specialtecken"
      },
      "password": {
        "title": "Ändra lösenord",
        "description": "Välj ett starkt lösenord som du inte använder någon annanstans",
        "current": "Nuvarande lösenord",
        "currentPlaceholder": "Ange nuvarande lösenord",
        "new": "Nytt lösenord",
        "newPlaceholder": "Ange nytt lösenord",
        "confirm": "Bekräfta nytt lösenord",
        "confirmPlaceholder": "Bekräfta nytt lösenord",
        "requirementsTitle": "Lösenordskrav:",
        "mismatch": "Lösenorden matchar inte",
        "submit": "Uppdatera lösenord"
      },
      "twoFactor": {
        "title": "Tvåfaktorsautentisering",
        "description": "Lägg till ett extra säkerhetslager på ditt konto",
        "authenticator": "Autentiseringsapp",
        "authenticatorDescription": "Använd en autentiseringsapp för att generera engångskoder",
        "enable": "Aktivera"
      },
      "danger": {
        "title": "Riskzon",
        "description": "Oåterkalleliga och destruktiva åtgärder",
        "deleteAccount": "Ta bort konto",
        "deleteAccountDescription": "Ta bort ditt konto och all tillhörande data permanent. Detta kan inte ångras.",
        "confirmTitle": "Är du helt säker?",
        "confirmDescription": "Denna åtgärd kan inte ångras. Detta kommer att permanent ta bort ditt konto och all din data från våra servrar.",
        "confirmAction": "Ja, ta bort mitt konto"
      }
    },
    "notifications": {
      "email": {
        "title": "E-postnotifieringar",
        "description": "Välj vilka e-postmeddelanden du vill få",
        "items": {
          "newJob": {
            "label": "Nya jobbtilldelningar",
            "description": "Få en notis när ett nytt jobb tilldelas dig"
          },
          "appointment": {
            "label": "Påminnelser om bokningar",
            "description": "Få påminnelser före kommande bokningar"
          },
          "marketing": {
            "label": "Produktuppdateringar och tips",
            "description": "Nyheter, funktionsuppdateringar och hjälpsamma tips"
          }
        }
      },
      "push": {
        "title": "Pushnotiser",
        "description": "Hantera pushnotiser i appen och webbläsaren",
        "items": {
          "newJob": {
            "label": "Nya jobbvarningar",
            "description": "Direkta notiser för nya jobbtilldelningar"
          },
          "appointment": {
            "label": "Bokningsvarningar",
            "description": "Pushnotiser för kommande bokningar"
          },
          "statusUpdate": {
            "label": "Statusuppdateringar",
            "description": "Få notiser när jobbstatus ändras"
          }
        }
      },
      "sms": {
        "title": "SMS-notifieringar",
        "description": "SMS-notiser för viktiga uppdateringar",
        "reminders": {
          "label": "SMS-påminnelser",
          "description": "Få SMS-påminnelser för bokningar"
        }
      },
      "save": "Spara inställningar"
    },
    "sessions": {
      "title": "Aktiva sessioner",
      "description": "Hantera enheter där du är inloggad just nu",
      "revoke": "Återkalla",
      "devices": {
        "chromeWindows": "Chrome på Windows",
        "safariIphone": "Safari på iPhone"
      },
      "locations": {
        "primary": "Motor City, MI"
      },
      "lastActive": {
        "now": "Nu",
        "hoursAgo_one": "för {{count}} timme sedan",
        "hoursAgo_other": "för {{count}} timmar sedan",
        "hoursAgo": "f?r {{count}} timmar sedan"
      },
      "signOutOthers": {
        "title": "Logga ut från alla andra sessioner",
        "description": "Detta loggar ut dig från alla enheter utom denna",
        "action": "Logga ut alla"
      }
    },
    "loginHistory": {
      "title": "Inloggningshistorik",
      "description": "Senaste inloggningsaktivitet på ditt konto",
      "status": {
        "success": "Lyckades",
        "failed": "Misslyckades"
      }
    },
    "toasts": {
      "profileUpdated": "Profilen uppdaterades",
      "changesDiscarded": "Ändringar kastades",
      "passwordRequirements": "Uppfyll alla lösenordskrav",
      "passwordsDoNotMatch": "De nya lösenorden matchar inte",
      "passwordUpdated": "Lösenordet ändrades",
      "sessionRevoked": "Sessionen återkallades",
      "accountDeletionRequested": "Begäran om kontoborttagning har skickats",
      "notificationPreferencesSaved": "Notifieringsinställningarna sparades",
      "allSessionsRevoked": "Alla andra sessioner återkallades"
    }
  },
  "errors": {
    "notFound": "Sidan hittades inte",
    "notFoundMessage": "Hoppsan! Sidan du letar efter finns inte.",
    "returnHome": "Tillbaka till startsidan",
    "somethingWentWrong": "Något gick fel",
    "tryAgain": "Försök igen",
    "unauthorized": "Obehörig",
    "forbidden": "Åtkomst nekad",
    "accessDenied": "Åtkomst nekad",
    "accessDeniedMessage": "Du har inte behörighet att visa denna sida. Kontakta din administratör om du tror att detta är ett misstag.",
    "unexpectedErrorOccurred": "Ett oväntat fel uppstod"
  },
  "topbar": {
    "howTo": "Hur man använder",
    "searchPlaceholder": "Sök reg-nr...",
    "new": "Ny",
    "dashboardSubtitle": "Översikt av ditt servicecenter",
    "schedulerSubtitle": "Hantera dagliga scheman och tilldelningar",
    "bookingSubtitle": "Visa och hantera alla tidsbokning",
    "newBookingSubtitle": "Skapa en ny servicetid",
    "customersSubtitle": "Hantera din kunddatabas",
    "newCustomerSubtitle": "Registrera en ny kund",
    "newCompanySubtitle": "Registrera ett nytt företagskonto",
    "vehiclesSubtitle": "Spåra registrerade fordon",
    "newVehicleSubtitle": "Lägg till ett fordon i registret",
    "servicesSubtitle": "Hantera din tjänstekatalog",
    "newServiceSubtitle": "Skapa ett nytt tjänsteerbjudande",
    "jobsSubtitle": "Spåra arbetsorder och servicejobb",
    "pricingSubtitle": "Hantera tjänsteprissättning och marginaler",
    "rolesSubtitle": "Konfigurera roller och åtkomstkontroll",
    "settingsSubtitle": "Systeminställningar och konfiguration",
    "accountSubtitle": "Hantera ditt personliga konto",
    "leavesSubtitle": "Spåra och hantera personalens ledighet",
    "workLogsSubtitle": "Övervaka daglig arbetstid",
    "billingSubtitle": "Hantera fakturor och betalningar",
    "productsSubtitle": "Hantera produktlager",
    "newProductSubtitle": "Lägg till en ny produkt i lagret",
    "rentalFleetSubtitle": "Hantera hyresfordonsflotta",
    "campaignsSubtitle": "Skapa och spåra marknadsföringskampanjer",
    "integrationsSubtitle": "Anslut verktyg och tjänster",
    "loanCarsSubtitle": "Hantera l?nebilar och tillg?nglighet",
    "categoriesSubtitle": "Hantera tjänst- och produktkategorier",
    "communicationSubtitle": "Hantera e-post- och SMS-mallar"
  },
  "theme": {
    "toggle": "Växla tema",
    "light": "Växla till ljust läge",
    "dark": "Växla till mörkt läge"
  },
  "dashboard": {
    "title": "Översikt",
    "welcome": "Välkommen tillbaka",
    "welcomeMessage": "Här är en översikt över ditt servicecenter.",
    "overview": "Översikt",
    "recentJobs": "Senaste jobb",
    "quickActions": "Snabbåtgärder",
    "weeklyNotes": "Veckans anteckningar",
    "weeklyTeamBoard": "Veckans teamtavla",
    "weekLabel": "Vecka {{week}}, {{year}}",
    "addNote": "Lägg till anteckning",
    "notePlaceholder": "Skriv din anteckning...",
    "noNotes": "Inga anteckningar denna vecka",
    "noNotesDay": "Inga anteckningar",
    "addNoteHint": "Klicka på 'Lägg till anteckning' för att skapa en",
    "goToCurrentWeek": "Gå till aktuell vecka",
    "weeklySummary": "Veckans sammanfattning",
    "weeklySummaryPlaceholder": "Lägg till en sammanfattning för veckan...",
    "dailyNotePlaceholder": "Lägg till en anteckning för denna dag...",
    "todayBadge": "Idag",
    "saveNotes": "Spara anteckningar",
    "executiveKPIs": "Nyckeltal",
    "statisticsAnalytics": "Statistik & Analys",
    "performanceMetrics": "Prestandamått och affärsinformation",
    "manageWeeklyNotes": "Hantera veckans anteckningar",
    "stats": {
      "totalCustomers": "Totalt antal kunder",
      "vehiclesRegistered": "Registrerade fordon",
      "activeJobs": "Aktiva jobb",
      "revenueMTD": "Intäkter (MTD)",
      "avgJobValue": "Snitt jobbvärde",
      "jobsThisWeek": "Jobb denna vecka"
    },
    "kpis": {
      "grossProfit": "Bruttovinst/Jobb",
      "monthlyRevenue": "Månadsintäkter",
      "avgLeadTime": "Snitt ledtid",
      "churnRate": "Churn Rate",
      "avgOrderValue": "Snitt ordervärde",
      "dso": "DSO",
      "firstTimeFix": "Första Fix-rate",
      "vsLastMonth": "jfr förra månaden",
      "bookingToCompletion": "bokning till slutförande",
      "twelveMonthInactive": "12 månader inaktiv",
      "inclUpsells": "inkl. merförsäljning",
      "daysSalesOutstanding": "dagar utestående försäljning",
      "noRepeatVisits": "inga återbesök",
      "totalRevenue": "Total intäkt",
      "laborPartsCombined": "Arbete + Delar kombinerat",
      "grossProfitMargin": "Bruttovinstmarginal",
      "afterPartCosts": "Efter delkostnader",
      "revenuePerInvoice": "Intäkt per faktura",
      "efficiencyRate": "Effektivitetsgrad",
      "billableVsClocked": "Fakturerbara vs loggade timmar",
      "workInProgress": "PÅGÅENDE ARBETE (WIP)",
      "openJobsNotInvoiced": "Öppna jobb ej fakturerade",
      "quoteConversion": "OFFERTKONVERTERING",
      "quotesToWorkOrders": "Offerter konverterade till arbetsorder",
      "checkInToCompletion": "Från incheckning till slutförande",
      "days": "dagar",
      "totalBookings": "Totalt antal bokningar",
      "thisMonth": "Denna månad",
      "totalEmployees": "Totalt antal anställda",
      "activeStaff": "Aktiv personal",
      "totalServices": "Totalt antal tjänster",
      "catalogServices": "Tj?nster i katalog",
      "liftEfficiency": "OEE (Lyftutnyttjande)",
      "billableLiftHours": "fakturerbara lyfttimmar",
      "availableServices": "Tillgängliga tjänster"
    },
    "today": {
      "bookings": "DAGENS BOKNINGAR",
      "revenue": "INTÄKTER (IDAG)",
      "activeCustomers": "AKTIVA KUNDER",
      "utilization": "BELÄGGNING"
    },
    "filters": {
      "today": "Idag",
      "thisWeek": "Denna vecka",
      "thisMonth": "Denna månad",
      "thisQuarter": "Detta kvartal",
      "thisYear": "Detta år",
      "allMechanics": "Alla mekaniker"
    },
    "workshopStatus": {
      "title": "STATUS",
      "carsIn": "Bilar inne"
    },
    "charts": {
      "revenueOverview": "Intäktsöversikt",
      "totalRevenue": "Total intäkt",
      "labor": "Arbete",
      "serviceBreakdown": "Tjänstefördelning",
      "weeklyEfficiency": "Veckoeffektivitet",
      "billableHours": "Fakturerbara timmar",
      "totalHours": "Totala timmar"
    },
    "lowInventory": "Varning lågt lager",
    "itemsLow": "artiklar lågt",
    "viewAllProducts": "Visa alla produkter",
    "todaysServices": "Dagens tjänster",
    "scheduled": "schemalagda",
    "viewSchedule": "Visa schema",
    "checkInList": "Incheckningslista",
    "actions": {
      "newCustomer": "Ny kund",
      "addVehicle": "Lägg till fordon",
      "createJob": "Skapa jobb",
      "newService": "Ny tjänst"
    }
  },
  "customers": {
    "title": "Kunder",
    "description": "Hantera din kunddatabas",
    "addCustomer": "Lägg till kund",
    "addCustomerDesc": "Lägg till en ny kund i databasen",
    "addCompany": "Lägg till företag",
    "addCompanyDesc": "Lägg till ett nytt företag i databasen",
    "namePlaceholder": "Ange kundnamn",
    "emailPlaceholder": "Ange e-postadress",
    "phonePlaceholder": "Ange telefonnummer",
    "customerAdded": "Kund tillagd",
    "searchPlaceholder": "Sök kunder...",
    "customer": "Kund",
    "vehicles": "Fordon",
    "totalSpent": "Totalt spenderat",
    "lastVisit": "Senaste besök",
    "emptyMessage": "Inga kunder hittades",
    "tabs": {
      "customers": "Kunder",
      "companies": "Företag"
    },
    "contactInfo": "Kontaktinformation",
    "totalVisits": "Totalt antal bes?k",
    "memberSince": "Medlem sedan",
    "bookingHistory": "Bokningshistorik",
    "companies": {
      "title": "Företag",
      "name": "Företagsnamn",
      "orgNumber": "Org.nr",
      "contact": "Kontakt",
      "location": "Plats",
      "city": "Stad",
      "driversCount": "Förare",
      "drivers": "förare",
      "searchPlaceholder": "Sök företag...",
      "emptyMessage": "Inga företag hittades",
      "addCompany": "Lägg till företag"
    },
    "form": {
      "companyInfo": "Företagsinformation",
      "companyInfoDesc": "Ange företagsuppgifter om kunden är ett företag",
      "personalInfo": "Personuppgifter",
      "personalInfoDesc": "Ange kundens personliga uppgifter",
      "orgNumber": "Organisationsnummer",
      "companyName": "Företagsnamn",
      "companyNamePlaceholder": "Ange företagsnamn",
      "reference": "Referens",
      "referencePlaceholder": "Ange referens",
      "address": "Adress",
      "addressPlaceholder": "Ange adress",
      "zipCode": "Postnummer",
      "city": "Stad",
      "country": "Land",
      "driverInfo": "Förarinformation",
      "driverInfoDesc": "Ange uppgifter för primär kontakt/förare",
      "firstName": "Förnamn",
      "firstNamePlaceholder": "Ange förnamn",
      "lastName": "Efternamn",
      "lastNamePlaceholder": "Ange efternamn",
      "externalNumber": "Externt nummer",
      "externalNumberPlaceholder": "Ange externt referensnummer",
      "hasCard": "Har kundkort",
      "hasCardDesc": "Markera om kunden har ett lojalitets-/medlemskort",
      "cardNumber": "Kortnummer",
      "cardValidTo": "Giltig till",
      "keyNumber": "Nyckelnummer",
      "cardKeyInfo": "Kort- & nyckelinformation",
      "consents": "Samtycken & Preferenser",
      "gdprAccept": "GDPR-samtycke",
      "gdprAcceptDesc": "Kunden har godkänt databehandlingsvillkor",
      "warrantyDriver": "Garantiförare",
      "warrantyDriverDesc": "Kunden är registrerad som garantiförare",
      "acceptsMarketing": "Marknadsföringssamtycke",
      "acceptsMarketingDesc": "Kunden accepterar marknadsföringskommunikation",
      "sharedNotes": "Delade anteckningar",
      "sharedNotesPlaceholder": "Anteckningar synliga för all personal...",
      "sharedNotesDesc": "Dessa anteckningar är synliga för all personal",
      "internalNotes": "Interna anteckningar",
      "internalNotesPlaceholder": "Privata anteckningar...",
      "internalNotesDesc": "Dessa anteckningar är endast synliga för ledningen",
      "notesTitle": "Anteckningar",
      "belongsToCompany": "Tillhör ett företag",
      "belongsToCompanyDesc": "Markera om kunden är kopplad till ett företag",
      "searchCompanyPlaceholder": "Sök på företagsnamn eller org.nummer...",
      "noCompaniesFound": "Inga matchande företag hittades",
      "createNewCompany": "Skapa nytt företag",
      "linked": "Kopplad",
      "hasVehicles": "Har fordon",
      "hasVehiclesDesc": "Koppla ett eller flera fordon till denna kund",
      "searchVehiclePlaceholder": "Sök på registreringsnummer...",
      "noVehiclesFound": "Inga matchande fordon hittades",
      "createNewVehicle": "Skapa nytt fordon",
      "noCustomersFound": "Inga kunder hittades.",
      "firstNameRequired": "Förnamn krävs",
      "lastNameRequired": "Efternamn krävs",
      "invalidEmail": "Ogiltig e-postadress",
      "phoneRequired": "Telefonnummer krävs",
      "clearSelection": "Rensa val",
      "cityPlaceholder": "Stockholm",
      "countryPlaceholder": "Sverige",
      "cardNumberPlaceholder": "XXXX-XXXX-XXXX",
      "keyNumberPlaceholder": "KEY-001",
      "emailFormatPlaceholder": "user@example.com",
      "companyEmailFormatPlaceholder": "company@example.com",
      "orgNumberRequired": "Organisationsnummer krävs",
      "companyNameRequired": "Företagsnamn krävs",
      "invalidPhoneFormat": "Ogiltigt telefonnummerformat"
    },
    "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras.",
    "customerUpdated": "Kunden uppdaterades",
    "jobHistory": "Jobbhistorik"
  },
  "uploads": {
    "images": "Bilder",
    "noImages": "Inga bilder uppladdade ännu",
    "profilePic": "Profilbild",
    "setProfilePic": "Ange som profilbild",
    "unsetProfilePic": "Ta bort som profilbild"
  },
  "vehicles": {
    "title": "Fordon",
    "description": "Hantera registrerade fordon",
    "addVehicle": "Lägg till fordon",
    "addVehicleDesc": "Lägg till ett nytt fordon i registret",
    "updateVehicle": "Uppdatera fordon",
    "updateVehicleDesc": "Ändra befintlig fordonsinformation",
    "vehicleAdded": "Fordon tillagt",
    "vehicleUpdated": "Fordon uppdaterat",
    "vehicleFound": "Fordon hittat - formuläret är ifyllt med befintlig data",
    "searchPlaceholder": "Sök fordon...",
    "vehicle": "Fordon",
    "licensePlate": "Registreringsnummer",
    "owner": "Ägare",
    "mileage": "Mätarställning",
    "lastService": "Senaste service",
    "emptyMessage": "Inga fordon hittades",
    "make": "M?rke",
    "allLoaded": "Alla fordon laddade",
    "vehicleDeleted": "Fordon raderat",
    "deleteConfirmTitle": "Radera fordon",
    "deleteConfirmDesc": "Detta kommer att mjukradera fordonet. Det kan återställas senare vid behov. Är du säker?",
    "model": "Modell",
    "year": "År",
    "form": {
      "registrationSearch": "Registreringsnummer",
      "registrationSearchDesc": "Ange fordonets registreringsnummer för att söka efter befintliga poster",
      "vehicleFoundWillUpdate": "Fordon hittades i systemet - formuläret uppdaterar befintlig post",
      "noVehicleFoundWillCreate": "Inget fordon hittades - en ny post kommer att skapas",
      "tempRegNumber": "Tillfällig registrering",
      "tempRegNumberDesc": "Markera om detta är ett tillfälligt registreringsnummer",
      "vehicleDetails": "Fordonsdetaljer",
      "vehicleDetailsDesc": "Grundläggande information om fordonet",
      "brand": "Märke",
      "model": "Modell",
      "year": "År",
      "color": "Färg",
      "horsePower": "Hästkrafter",
      "mileage": "Mätarställning (km)",
      "technicalDetails": "Tekniska detaljer",
      "technicalDetailsDesc": "Motor- och transmissionsspecifikationer",
      "fuelType": "Bränsletyp",
      "gearType": "Växellåda",
      "carType": "Biltyp",
      "registrationDate": "Registreringsdatum",
      "additionalInfo": "Ägare & Övrig information",
      "owner": "Fordonsägare",
      "ownerSearchDesc": "Sök och koppla en ägare till fordonet",
      "ownerSearchPlaceholder": "Sök på namn, e-post eller telefon...",
      "ownerLinked": "Kopplad",
      "noOwnersFound": "Inga matchande ägare hittades",
      "createNewOwner": "Skapa ny ägare",
      "carID": "Bil-ID",
      "carIDPlaceholder": "Ange bilidentifierare",
      "notes": "Anteckningar",
      "notesPlaceholder": "Eventuella ytterligare anteckningar om detta fordon...",
      "immutableHint": "Detta fält kan inte ändras efter skapande",
      "engineSpecifications": "Motorspecifikation",
      "status": "Status",
      "additionalDetailsDesc": "Lägg till ägare och kompletterande fordonsuppgifter",
      "brandPlaceholder": "Toyota",
      "modelPlaceholder": "Camry",
      "registrationRequired": "Registreringsnummer krävs",
      "yearMustBeNumber": "Året måste vara ett nummer",
      "yearAfter1901": "Året måste vara efter 1901",
      "yearNotGreaterThan": "Året kan inte vara senare än {{year}}",
      "horsePowerNegative": "Hästkrafter kan inte vara negativt",
      "horsePowerTooLarge": "Hästkrafter är för högt",
      "mileageNegative": "Miltal kan inte vara negativt",
      "mileageTooLarge": "Miltal är för högt",
      "regDateFuture": "Registreringsdatum kan inte vara i framtiden",
      "fuelTypeOptions": {
        "Diesel": "Diesel",
        "Gasoline": "Bensin",
        "Electric": "El",
        "Hybrid": "Hybrid",
        "Hydrogen": "Vätgas"
      },
      "gearTypeOptions": {
        "Manual": "Manuell",
        "Automatic": "Automat"
      },
      "carTypeOptions": {
        "Sedan": "Sedan",
        "SUV": "SUV",
        "Truck": "Lastbil",
        "Coupe": "Coupé",
        "Convertible": "Cabriolet"
      },
      "colorOptions": {
        "LightBlue": "Ljusblå",
        "Blue": "Blå",
        "DarkBlue": "Mörkblå",
        "LightGreen": "Ljusgrön",
        "Green": "Grön",
        "DarkGreen": "Mörkgrön",
        "LightYellow": "Ljusgul",
        "Yellow": "Gul",
        "DarkYellow": "Mörkgul",
        "LightPurple": "Ljuslila",
        "Purple": "Lila",
        "DarkPurple": "Mörklila",
        "LightPink": "Ljusrosa",
        "Pink": "Rosa",
        "DarkPink": "Mörkrosa",
        "LightTurquoise": "Ljusturkos",
        "Turquoise": "Turkos",
        "DarkTurquoise": "Mörkturkos",
        "Orange": "Orange",
        "Red": "Röd",
        "None": "Ingen"
      }
    },
    "editVehicle": "Redigera fordon",
    "lockFields": "Lås fält",
    "readOnlyHint": "Klicka på 'Redigera fordon' för att låsa upp fält. Vissa fält kan inte ändras efter skapande.",
    "blacklist": "Svartlista",
    "removeBlacklist": "Ta bort svartlistning",
    "blacklisted": "Fordonet har svartlistats",
    "unblacklisted": "Fordonet har tagits bort från svartlistan",
    "blacklistedBadge": "Svartlistad",
    "vin": "Chassinummer",
    "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras.",
    "filters": {
      "fuelPetrol": "Bensin",
      "fuelDiesel": "Diesel",
      "fuelElectric": "El",
      "fuelHybrid": "Hybrid",
      "typeSedan": "Sedan",
      "typeSuv": "SUV",
      "typeHatchback": "Halvkombi"
    }
  },
  "services": {
    "title": "Tjänster",
    "description": "Hantera din tjänstekatalog och prissättning",
    "addService": "Lägg till tjänst",
    "addServiceDesc": "Skapa en ny tjänst för din katalog",
    "searchPlaceholder": "Sök tjänster...",
    "popular": "Populär",
    "categoryFilter": "Filtrera efter kategori",
    "duration": "Varaktighet (min)",
    "serviceImage": "Tjänstebild",
    "namePlaceholder": "t.ex. Oljebyte",
    "descriptionPlaceholder": "Kort beskrivning av tjänsten",
    "serviceAdded": "Tjänst tillagd",
    "emptyMessage": "Inga tjänster hittades",
    "form": {
      "basicInfo": "Grundläggande information",
      "basicInfoDesc": "Lägg till grundläggande information för den nya tjänsten.",
      "pricingDuration": "Pris- och tidsinformation",
      "pricingDurationDesc": "Lägg till pris- och tidsinformation för den nya tjänsten.",
      "options": "Övriga alternativ",
      "status": "Status",
      "color": "Färg",
      "award": "Ersättning",
      "itemNumber": "Artikelnummer",
      "suppliersArticleNumber": "Leverantörens artikelnummer",
      "externalArticleNumber": "Externt artikelnummer",
      "includeInAutomaticSms": "Inkludera i automatiska SMS",
      "hidden": "Dold",
      "warrantyCard": "Garantikort",
      "blacklisted": "Svartlistad",
      "validation": {
        "nameRequired": "Tjänstens namn är obligatoriskt",
        "costNonNegative": "Priset måste vara noll eller högre",
        "categoryRequired": "Kategori krävs"
      }
    },
    "category": "Kategori",
    "selectCategory": "Välj kategori",
    "categories": {
      "all": "Alla",
      "maintenance": "Underhåll",
      "safety": "Säkerhet",
      "diagnostics": "Diagnostik",
      "comfort": "Komfort"
    },
    "service": "Tjänst",
    "serviceUpdated": "Tjänsten uppdaterades",
    "deleted": "Tjänsten togs bort"
  },
  "jobs": {
    "title": "Jobb",
    "description": "Hantera arbetsorder och servicejobb",
    "createJob": "Skapa jobb",
    "createJobDesc": "Skapa en ny arbetsorder",
    "selectCustomer": "V?lj en kund",
    "selectTechnician": "V?lj en tekniker",
    "jobCreated": "Jobb skapades",
    "jobUpdated": "Jobb uppdaterades",
    "deleted": "Jobbet raderades",
    "deleteConfirm": "Är du säker på att du vill ta bort jobbet {{name}}? Detta kan inte ångras.",
    "searchPlaceholder": "Sök jobb...",
    "jobId": "Jobb-ID",
    "customerVehicle": "Kund & Fordon",
    "assignedTo": "Tilldelad till",
    "scheduled": "Schemalagt",
    "total": "Totalt",
    "unassigned": "Ej tilldelad",
    "emptyMessage": "Inga jobb hittades",
    "estimatedTime": "Ber. tid",
    "details": "Jobbdetaljer",
    "notes": "Anteckningar",
    "status": "Status",
    "statusFilters": {
      "all": "Alla",
      "pending": "Väntande",
      "inProgress": "Pågående",
      "completed": "Slutförda",
      "cancelled": "Avbokade",
      "preliminary": "Preliminär",
      "created": "Skapad",
      "inShop": "I verkstad",
      "startService": "Under service",
      "started": "Under service",
      "pickedUp": "Upphämtad",
      "pickup": "Upphämtad",
      "archived": "Arkiverad",
      "finished": "Klar"
    },
    "technician": "Tekniker",
    "orderID": "Order-ID",
    "orderNumber": "Order #",
    "dropOff": "Inlämning",
    "plannedPickup": "Planerad upphämtning",
    "actualDropOff": "Faktisk inlämning",
    "actualPickup": "Faktisk upphämtning",
    "billed": "Fakturerad",
    "notBilled": "Ej fakturerad",
    "workSchedule": "Arbetsschema",
    "vatFree": "Momsfri",
    "kanbanStatus": "Kanban-status",
    "serviceNotes": "Tjänsteanteckningar",
    "productNotes": "Produktanteckningar"
  },
  "pricing": {
    "title": "Priser",
    "description": "Hantera tjänsteprissättning och vinstmarginaler",
    "addPricing": "Lägg till pris",
    "searchPlaceholder": "Sök tjänster...",
    "service": "Tjänst",
    "category": "Kategori",
    "laborRate": "Arbetskostnad",
    "partsCost": "Delkostnad",
    "basePrice": "Grundpris",
    "margin": "Marginal",
    "totalServicesValue": "Totalt tjänstevärde",
    "avgProfitMargin": "Snitt vinstmarginal",
    "activePricingItems": "Aktiva prisartiklar"
  },
  "roles": {
    "title": "Roller & Behörigheter",
    "description": "Hantera användarroller, åtkomstkontroll och arbetstider",
    "createRole": "Skapa roll",
    "createPermission": "Skapa behörighet",
    "createRoleDesc": "Definiera en ny roll med namn och beskrivning",
    "deleteRole": "Ta bort roll",
    "deleteRoleConfirm": "Är du säker på att du vill ta bort rollen \"{{name}}\"? Denna åtgärd kan inte ångras.",
    "roleCreated": "Roll skapad",
    "roleUpdated": "Roll uppdaterad",
    "roleDeleted": "Roll borttagen",
    "roleName": "Rollnamn",
    "roleNamePlaceholder": "t.ex. Arbetsledare",
    "roleDescription": "Beskrivning",
    "roleDescPlaceholder": "Beskriv vad denna roll kan göra...",
    "roleColor": "Färg",
    "colorRed": "Röd",
    "colorBlue": "Blå",
    "colorGreen": "Grön",
    "colorGray": "Grå",
    "addPermission": "Lägg till behörighet",
    "addPermissionDesc": "Skapa en ny behörighet med nyckel, visningsnamn och beskrivning",
    "editPermission": "Redigera behörighet",
    "editPermissionDesc": "Uppdatera behörighetens namn och beskrivning",
    "deletePermission": "Ta bort behörighet",
    "deletePermissionConfirm": "Är du säker på att du vill ta bort behörigheten \"{{name}}\"? Denna åtgärd kan inte ångras.",
    "permissionCreated": "Behörighet skapad",
    "permissionUpdated": "Behörighet uppdaterad",
    "permissionDeleted": "Behörighet borttagen",
    "permissionKey": "Behörighetsnyckel",
    "permissionKeyPlaceholder": "t.ex. customer:view",
    "permissionName": "Visningsnamn",
    "permissionNamePlaceholder": "t.ex. Exportera data",
    "permissionDescription": "Beskrivning",
    "permissionDescPlaceholder": "Beskriv vad denna behörighet tillåter...",
    "permissionCategoryLabel": "Kategori",
    "admin": "Administratör",
    "user": "Användare",
    "moderator": "Moderator",
    "manager": "Chef",
    "technician": "Tekniker",
    "receptionist": "Receptionist",
    "permissions": "Behörigheter",
    "manageRoles": "Hantera roller",
    "users": "användare",
    "rolesLabel": "Roller",
    "enabled": "aktiverat",
    "noPermissionsFound": "Inga behörigheter hittades",
    "noRolesFound": "Inga roller hittades",
    "searchPermissionsPlaceholder": "Sök behörigheter...",
    "noPermissionsMatchSearch": "Inga behörigheter matchar din sökning",
    "validation": {
      "titleRequired": "Titel krävs"
    },
    "createForm": {
      "addPermission": "Lägg till behörighet",
      "addRole": "Lägg till roll",
      "addPermissionDesc": "Skapa en ny global behörighet med titel och valfri beskrivning.",
      "addRoleDesc": "Skapa en ny roll med titel och valfri beskrivning.",
      "permissionName": "Behörighetsnamn",
      "permissionNamePlaceholder": "t.ex. bookings:read",
      "roleName": "Rollnamn",
      "roleNamePlaceholder": "t.ex. Arbetsledare",
      "permissionDescription": "Beskrivning av behörighet",
      "permissionDescPlaceholder": "Beskriv vad denna behörighet tillåter.",
      "roleDescription": "Rollbeskrivning",
      "roleDescPlaceholder": "Beskriv syftet med denna roll."
    },
    "workTimings": {
      "title": "Arbetstider",
      "description": "Konfigurera specialscheman för denna roll",
      "defaultSchedule": "Standardschema",
      "customSchedule": "Anpassat schema",
      "useCustomSchedule": "Använd anpassat schema",
      "useCustomScheduleDesc": "Aktivera för att ställa in anpassade arbetstider för denna roll",
      "workDays": "Arbetsdagar",
      "shiftStart": "Skiftstart",
      "shiftEnd": "Skiftslut",
      "breakDuration": "Rastlängd (min)",
      "breakDurationDesc": "Rastens längd i minuter (0-120)",
      "overtime": "Övertid tillåten",
      "overtimeAllowed": "Övertid tillåten",
      "overtimeAllowedDesc": "Tillåt anställda med denna roll att arbeta övertid",
      "maxOvertimeHours": "Max övertid timmar/vecka",
      "maxOvertimeHoursDesc": "Maximalt antal övertidstimmar tillåtna per vecka (0-40)"
    },
    "dashboard": {
      "title": "Dashboard",
      "configureInfo": "Konfigurera vilka dashboard-kort som visas på startsidan för användare med denna roll.",
      "usersCanCustomize": "Användare kan anpassa sin egen layout senare.",
      "availableModules": "Tillgängliga Dashboard-moduler",
      "selectUpTo4": "Välj upp till 4",
      "dashboardOrder": "Dashboard-ordning",
      "dragToReorder": "Dra för att ordna hur kort visas på startsidan",
      "selected": "Vald",
      "select": "Välj",
      "maxModules": "Du kan välja upp till 4 moduler",
      "modules": {
        "mySchedule": "Mitt schema",
        "myScheduleDesc": "Mini-kalender",
        "overdueTasks": "Försenade uppgifter & aktiviteter",
        "overdueTasksDesc": "Uppgiftshantering",
        "salesPipeline": "Försäljningspipeline",
        "salesPipelineDesc": "CRM/Pipelines",
        "outstandingInvoices": "Utestående fakturor & kundfordringar",
        "outstandingInvoicesDesc": "Finans & fakturering",
        "lowStock": "Lågt lager & beställningsvarningar",
        "lowStockDesc": "Lagerhantering",
        "absenceRequests": "Frånvaro & semesterförfrågningar",
        "absenceRequestsDesc": "HR-hantering",
        "marketingPerformance": "Marknadsföring/SEO-prestanda",
        "marketingPerformanceDesc": "Marknadsföringsanalys",
        "teamEfficiency": "Teamets WO-effektivitet",
        "teamEfficiencyDesc": "Arbetsorderanalys"
      },
      "preview": {
        "appointmentsToday": "{{count}} möten idag",
        "overdueCount": "{{count}} försenade",
        "followUpClient": "Följ upp kund",
        "sendProposal": "Skicka offert",
        "pipelineValue": "Pipelinevärde",
        "outstanding": "Utestående",
        "overdue": "Försenat",
        "lowStockCount": "{{count}} lågt lager",
        "screwsExample": "Skruvar M8x40",
        "screwsQty": "12 st",
        "cableExample": "Kabel 2x2,5",
        "cableQty": "5m",
        "absenceExample1": "Anna S. - Semester",
        "review": "Granska",
        "absenceExample2": "Erik L. - Sjuk",
        "newLeads": "Nya leads",
        "traffic": "Trafik",
        "avgTime": "Snitttid"
      }
    }
  },
  "settings": {
    "title": "Inställningar",
    "description": "Hantera dina systeminställningar och konfigurationer",
    "saveChanges": "Spara ändringar",
    "tabs": {
      "branchInfo": "Filialinfo",
      "workingHours": "Arbetstider",
      "staff": "Personal",
      "permissions": "Behörigheter",
      "integrations": "Integrationer",
      "qualifications": "Kvalifikationer",
      "weeklyNotes": "Veckans anteckningar",
      "stores": "Butiker",
      "unionAgreements": "Kollektivavtal",
      "categories": "Kategorier",
      "communication": "Kommunikation",
      "services": "Tjänster",
      "packages": "Paket",
      "absenceTypes": "Frånvarotyper"
    },
    "stores": {
      "title": "Butiker",
      "description": "Hantera alla butiker i din organisation",
      "newStore": "Ny butik",
      "newStoreDesc": "Lägg till en ny butiksplats i din organisation",
      "storesCount": "butiker",
      "basicInfo": "Grundl?ggande information",
      "storeName": "Butiksnamn",
      "website": "Webbplats",
      "storeNamePlaceholder": "t.ex. Huvudkontor",
      "location": "Plats",
      "storeDescription": "Butiksbeskrivning",
      "contactPerson": "Kontaktperson",
      "businessInfo": "F?retagsinformation",
      "vatNumber": "Momsregistreringsnummer",
      "workshopCapacity": "Verkstadskapacitet",
      "storeStatus": "Butik aktiv",
      "contact": "Kontaktinformation",
      "email": "E-postadress",
      "phone": "Telefonnummer",
      "addressinfo": "Fullst?ndig adress",
      "address": "Adress",
      "zipCode": "Postnummer",
      "city": "Stad",
      "country": "Land",
      "features": "Ytterligare funktioner",
      "payment": "Betalningsalternativ",
      "bankgiro": "Bankgiro",
      "plusgiro": "Plusgiro",
      "paymentDays": "Betaldagar",
      "noStores": "Inga butiker hittades",
      "storeInfo": "Butiksinformation",
      "contactAddress": "Kontakt & adress",
      "addressPlaceholder": "t.ex. Industrivägen 12",
      "cityPlaceholder": "t.ex. Stockholm",
      "zipCodePlaceholder": "t.ex. 111 22",
      "additionalNotes": "Ytterligare anteckningar",
      "notesPlaceholder": "Eventuella ytterligare anteckningar om denna butik...",
      "createStore": "Skapa butik",
      "fillRequired": "Vänligen fyll i alla obligatoriska fält",
      "storeCreated": "Butik skapad",
      "storeUpdated": "Butik uppdaterad",
      "storeDetailsDesc": "Visa och redigera butiksdetaljer",
      "deleteStore": "Ta bort butik",
      "deleteStoreConfirm": "Är du säker på att du vill ta bort den här butiken? Denna åtgärd kan inte ångras.",
      "manager": "Ansvarig",
      "managerPlaceholder": "t.ex. Erik Andersson",
      "capacity": "Kapacitet",
      "lifts": "lyftar",
      "bays": "platser",
      "basicInfoDesc": "Allmänna uppgifter och identitet för butiken",
      "businessInfoDesc": "Skatte- och organisationsidentifierare",
      "contactDesc": "Telefon och e-post för denna butik",
      "addressDesc": "Butikens fysiska plats",
      "featuresDesc": "Aktivera eller inaktivera funktioner för denna butik",
      "paymentDesc": "Konfigurera betalningsidentifierare och villkor",
      "currency": "Valuta",
      "orgNumber": "Organisationsnummer",
      "maxUsers": "Max användare",
      "fSkatt": "F-Skatt",
      "allowCarAPI": "Tillåt bil-API",
      "allowSendSMS": "Tillåt SMS-utskick",
      "sendSMS": "Skicka SMS",
      "usesCheckin": "Använder incheckning",
      "usesPIN": "Använder PIN",
      "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Åtgärden kan inte ångras.",
      "storeDetails": "Butiksdetaljer",
      "storeNameRequired": "Butiksnamn krävs",
      "invalidEmail": "Ogiltig e-postadress",
      "websitePlaceholder": "https://example.com",
      "vatNumberPlaceholder": "SE556000000001",
      "emailPlaceholder": "store@example.com",
      "countryPlaceholder": "Sverige"
    },
    "users": {
      "title": "Användarhantering",
      "description": "Hantera användare och deras åtkomst till organisationen",
      "totalUsers": "{{count}} användare i organisationen",
      "inviteUser": "Bjud in användare",
      "inviteUserDesc": "Skicka en inbjudan för att lägga till en ny användare i din organisation",
      "namePlaceholder": "Ange användarens namn",
      "emailPlaceholder": "Ange användarens e-post",
      "role": "Roll",
      "selectRole": "Välj en roll",
      "activeUser": "Aktiv",
      "sendInvite": "Skicka inbjudan",
      "userInvited": "Användarinbjudan skickad",
      "userRemoved": "Användare borttagen",
      "fillAllFields": "Vänligen fyll i alla obligatoriska fält",
      "noUsers": "Inga användare hittades",
      "employeeDetails": "Medarbetaruppgifter",
      "stores": "Tilldelade butiker",
      "overview": "Kontoöversikt",
      "userStatus": "Kontostatus",
      "employeeStatus": "Anställningsstatus",
      "noRole": "Ingen roll tilldelad",
      "noStores": "Inga butiker tilldelade",
      "staffMember": "Personalmedlem",
      "personalInfo": "Personlig information",
      "roleAndStatus": "Roll & Status",
      "workInfo": "Arbetsinformation",
      "shortUserName": "Kortnamn",
      "hourlyRate": "Timlön",
      "hourlyRateCurrency": "Timlönevaluta",
      "pin": "PIN",
      "signature": "Signatur",
      "comment": "Kommentar",
      "userID": "Användar-ID",
      "employmentNumber": "Anställningsnummer",
      "personalNumber": "Personnummer",
      "deleteUser": "Ta bort användare",
      "deleteUserConfirm": "Är du säker på att du vill ta bort {{name}}? Åtgärden kan inte ångras.",
      "validation": {
        "firstNameMin": "Förnamnet måste vara minst 3 tecken",
        "lastNameMin": "Efternamnet måste vara minst 3 tecken",
        "emailInvalid": "Ange en giltig e-postadress",
        "passwordMin": "Lösenordet måste vara minst 8 tecken",
        "passwordUppercase": "Måste innehålla minst en stor bokstav",
        "passwordLowercase": "Måste innehålla minst en liten bokstav",
        "passwordNumber": "Måste innehålla minst en siffra",
        "passwordSpecial": "Måste innehålla minst ett specialtecken",
        "roleRequired": "Välj en roll"
      },
      "hr": {
        "title": "HR & Ersättning",
        "section": "HR-profil",
        "hourlyRate": "Timpris",
        "baseSalary": "Grundlön",
        "commissionPct": "Provision %",
        "mileageRate": "Kilometerersättning",
        "currency": "Valuta",
        "hoursPerWeek": "Timmar/Vecka",
        "leaveBalances": "Ledighetssaldo (dagar/år)",
        "vacation": "Semester",
        "sick": "Sjuk",
        "vab": "VAB",
        "parental": "Föräldra",
        "rate": "Pris",
        "salary": "Månad",
        "remaining": "Kvar",
        "saved": "HR-profil uppdaterad",
        "edit": "Redigera HR-profil"
      },
      "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Åtgärden kan inte ångras.",
      "username": "Användarnamn",
      "required": "Obligatoriskt",
      "invalidEmail": "Ogiltig e-postadress",
      "minPasswordLength": "Måste vara minst 6 tecken",
      "shortUserNamePlaceholder": "ABCD",
      "currencyPlaceholder": "CCY"
    },
    "branchInfo": {
      "title": "Företagsinformation",
      "description": "Hantera dina företagsuppgifter och kontaktinformation",
      "branchName": "Företagsnamn",
      "branchInfo": "Företagsinformation",
      "phone": "Telefonnummer",
      "email": "E-postadress",
      "address": "Adress"
    },
    "workingHours": {
      "title": "Öppettider",
      "description": "Ställ in verkstadens öppettider",
      "monday": "Måndag",
      "tuesday": "Tisdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lördag",
      "sunday": "Söndag",
      "to": "till",
      "applyToAll": "Tillämpa på alla",
      "appliedToAll": "Måndagens tider tillämpade på alla dagar",
      "specialHours": "Särskilda öppettider",
      "addSpecialHour": "Lägg till särskilda tider",
      "noSpecialHours": "Inga särskilda öppettider konfigurerade",
      "specialName": "t.ex. Julafton, Midsommar...",
      "saved": "Arbetstider sparade",
      "closed": "Stängt"
    },
    "notifications": {
      "title": "Notifikationer",
      "description": "Konfigurera hur du tar emot notifikationer",
      "emailNotifications": "E-postnotifikationer",
      "emailNotificationsDesc": "Få e-postuppdateringar för nya jobb och kunder",
      "jobCompletionAlerts": "Jobbslutförandevarningar",
      "jobCompletionAlertsDesc": "Bli notifierad när ett jobb slutförs",
      "dailySummary": "Daglig sammanfattning",
      "dailySummaryDesc": "Få en daglig sammanfattning av aktiviteter"
    },
    "emailTemplates": {
      "title": "E-postmallar",
      "description": "Anpassa e-postmallar för kundkommunikation",
      "jobConfirmation": "Jobbbekräftelse",
      "jobConfirmationDesc": "Skickas när ett nytt jobb skapas",
      "jobCompletion": "Jobbslutförande",
      "jobCompletionDesc": "Skickas när ett jobb slutförs",
      "invoice": "Faktura",
      "invoiceDesc": "Skickas med fakturan efter betalning"
    },
    "security": {
      "title": "Säkerhet",
      "description": "Hantera säkerhetsinställningar och åtkomstkontroller",
      "twoFactor": "Tvåfaktorsautentisering",
      "twoFactorDesc": "Lägg till ett extra säkerhetslager",
      "sessionTimeout": "Sessionsutgång",
      "sessionTimeoutDesc": "Automatisk utloggning efter 30 minuters inaktivitet",
      "changePassword": "Ändra lösenord"
    },
    "dataBackup": {
      "title": "Data & Säkerhetskopiering",
      "description": "Hantera dina data och säkerhetskopieringsinställningar",
      "autoBackup": "Automatisk säkerhetskopiering",
      "autoBackupDesc": "Säkerhetskopiera data automatiskt dagligen",
      "exportData": "Exportera data",
      "importData": "Importera data"
    },
    "storeCreated": "Butiken skapades",
    "storeDeleted": "Butiken togs bort",
    "storeUpdated": "Butiken uppdaterades",
    "weeklyNotes": {
      "title": "Veckans anteckningar",
      "description": "Hantera veckosammanfattningar och dagliga anteckningar f?r ditt team",
      "dailyNotes": "Dagliga anteckningar",
      "noteSaved": "Anteckningen sparades",
      "noteDeleted": "Anteckningen togs bort",
      "summarySaved": "Veckosammanfattningen sparades",
      "noteSaveFailed": "Anteckningen kunde inte sparas. Försök igen.",
      "noteDeleteFailed": "Anteckningen kunde inte tas bort. Försök igen.",
      "summarySaveFailed": "Veckosammanfattningen kunde inte sparas. Försök igen."
    },
    "businessInfo": {
      "title": "Företagsinformation",
      "description": "Hantera dina företagsuppgifter och kontaktinformation",
      "businessName": "Företagsnamn",
      "companyInfo": "Företagsinformation",
      "companyName": "Företagsnamn",
      "orgNumber": "Organisationsnummer",
      "vatNumber": "Momsnummer",
      "phone": "Telefonnummer",
      "email": "E-postadress",
      "address": "Adress",
      "workshopDetails": "Verkstadsdetaljer",
      "numberOfLifts": "Antal lyftar",
      "numberOfBays": "Antal platser"
    },
    "branchInfoAccessDenied": "Du har inte åtkomst att visa den här butikens information",
    "headers": {
      "branchInfo": {
        "title": "Filialinformation",
        "description": "Hantera dina företagsuppgifter och kontaktinformation."
      },
      "workingHours": {
        "title": "Butikens öppettider",
        "description": "Ange verkstadens öppettider och speciella dagar."
      },
      "staff": {
        "title": "Personal",
        "description": "Hantera anställda, roller, ersättning och ledighetssaldo."
      },
      "permissions": {
        "title": "Roller & Behörigheter",
        "description": "Definiera organisationsroller och åtkomstbehörigheter."
      },
      "stores": {
        "title": "Butiker",
        "description": "Hantera alla butiker i din organisation."
      },
      "qualifications": {
        "title": "Kvalifikationer",
        "description": "Spåra personalens certifieringar och färdigheter."
      },
      "unionAgreements": {
        "title": "Kollektivavtal",
        "description": "Hantera kollektivavtal som tillämpas på anställda."
      },
      "weeklyNotes": {
        "title": "Veckonoteringar",
        "description": "Lägg till dagliga och veckovisa anteckningar som visas på dashboarden."
      },
      "integrations": {
        "title": "Integrationer",
        "description": "Anslut tredjepartstjänster till din verkstad."
      },
      "categories": {
        "title": "Kategorier",
        "description": "Organisera tjänster och produkter i kategorier."
      },
      "services": {
        "title": "Tjänster",
        "description": "Hantera tjänsterna som din verkstad erbjuder."
      },
      "communication": {
        "title": "Kommunikation",
        "description": "Anpassa e-post- och SMS-mallar som skickas till kunder."
      }
    }
  },
  "booking": {
    "title": "Bokning",
    "description": "Hantera tidsbokning och servicebokningar",
    "progressLabel": "Bokningsframsteg",
    "weeklyOverview": "Veckoöversikt",
    "bookings": "bokningar",
    "steps": {
      "date": "Datum",
      "selection": "Val",
      "services": "Tjänster",
      "checkout": "Kassa",
      "customer": "Kund",
      "vehicle": "Fordon",
      "schedule": "Schema",
      "rentCars": "Hyrbil",
      "vehicleImages": "Fordonsbilder",
      "confirm": "Bekräfta"
    },
    "vehicleImages": {
      "title": "Fordonsbilder",
      "description": "Ladda upp bilder på fordonet från olika vinklar. Detta steg är valfritt.",
      "optional": "Valfritt",
      "upload": "Ladda upp",
      "files": "filer",
      "emptyHint": "Inga bilder tillagda ännu",
      "categories": {
        "front": "Fram",
        "left": "Vänster sida",
        "right": "Höger sida",
        "rear": "Bak",
        "interior": "Interiör",
        "tyres": "Däck",
        "damage": "Skador (markera tydligt)"
      }
    },
    "selectDate": "Välj datum",
    "selectDateDesc": "Välj ett datum för tidsbokningen från kalendern ovan",
    "changeDate": "Ändra datum",
    "clickCalendarToSelect": "Klicka på ett datum i kalendern ovan för att välja",
    "date": "Datum",
    "selectCustomerVehicle": "Välj kund & fordon",
    "selectCustomerVehicleDesc": "Välj efter kund eller fordon",
    "byCustomer": "Via kund",
    "byVehicle": "Via fordon",
    "assignEmployee": "Tilldela anställd",
    "assignEngineers": "Tilldela tekniker",
    "assignEngineersDesc": "Välj tekniker för {{service}}",
    "selectEngineers": "Välj en eller flera tekniker",
    "selectCustomer": "Välj kund",
    "selectCustomerDesc": "Välj en befintlig kund eller skapa en ny",
    "searchCustomers": "Sök kunder efter namn, e-post eller telefon...",
    "customerList": "Kundlista",
    "selectVehicle": "Välj fordon",
    "selectVehicleDesc": "Välj fordonet för denna service",
    "searchVehicles": "Sök fordon efter märke, modell eller registreringsnummer...",
    "vehicleList": "Fordonslista",
    "selectServices": "Välj tjänster",
    "selectServicesDesc": "Lägg till tjänster till denna bokning",
    "searchServices": "Sök tjänster...",
    "filterByCategory": "Filtrera efter kategori",
    "serviceList": "Tillgängliga tjänster",
    "checkout": "Kassa & Schemalägg",
    "checkoutDesc": "Granska och slutför bokningen",
    "scheduledDate": "Schemalagt datum",
    "scheduledTime": "Schemalagd tid",
    "notes": "Anteckningar",
    "notesPlaceholder": "Lägg till eventuella speciella instruktioner eller anteckningar...",
    "createJob": "Skapa jobb",
    "jobCreated": "Jobb skapat framgångsrikt!",
    "summary": "Bokningssammanfattning",
    "customer": "Kund",
    "vehicle": "Fordon",
    "selectedServices": "Valda tjänster",
    "estimatedDuration": "Beräknad varaktighet",
    "estimatedTime": "Beräknad tid",
    "total": "Totalt",
    "subtotal": "Delsumma",
    "vat": "Moms",
    "vatFree": "Momsfri",
    "discount": "Rabatt",
    "discountPercent": "Procent",
    "discountFixed": "Fast belopp",
    "preliminary": "Preliminär bokning",
    "preliminaryDesc": "Markera detta som en tentativ bokning som behöver bekräftelse",
    "emptySummary": "Börja med att välja en kund",
    "quantity": "Antal",
    "increaseQuantity": "Öka antal",
    "decreaseQuantity": "Minska antal",
    "advancedOptions": "Avancerat",
    "advancedMode": "Avancerat läge",
    "autoAssign": "Automatisk tilldelning",
    "reviewBooking": "Granska din bokning",
    "reviewDescription": "Vänligen verifiera alla detaljer innan du bekräftar",
    "customerVehicle": "Kund & fordon",
    "scheduleDetails": "Schemaläggningsdetaljer",
    "intakeTime": "Inlämningstid",
    "intakeTimeDesc": "När kunden lämnar in fordonet",
    "deliveryTime": "Utlämningstid (efter arbete)",
    "deliveryTimeDesc": "När fordonet är klart för upphämtning",
    "intake": "Inlämning",
    "delivery": "Utlämning",
    "loanCar": "Lånebil",
    "selectLoanCar": "Välj en tillgänglig lånebil",
    "needsLoanCar": "Kunden behöver en lånebil",
    "addNewCustomer": "Lägg till ny kund",
    "addNewVehicle": "Lägg till nytt fordon",
    "noResultsFor": "Inga resultat hittades för \"{{search}}\"",
    "noCustomersFound": "Inga kunder hittades. Lägg till en ny.",
    "noVehiclesFound": "Inga fordon hittades. Lägg till ett nytt.",
    "employeeOnLeave": "Ledig",
    "employeeUnavailable": "Denna anställd är ledig det valda datumet",
    "startTime": "Starttid",
    "endTime": "Sluttid",
    "serviceDetails": "Tjänstedetaljer",
    "variant": "Variant",
    "variantPlaceholder": "t.ex. Standard, Premium, Full...",
    "specialPrice": "Specialpris",
    "regularPrice": "Ordinarie pris",
    "lineTotal": "Radsumma",
    "serviceNotes": "Tjänsteanteckningar",
    "serviceNotesPlaceholder": "Lägg till anteckningar specifika för denna tjänst...",
    "printBooking": "Skriv ut bokning",
    "vehicleTransfer": {
      "title": "Överför fordonsägande",
      "description": "Detta fordon är för närvarande registrerat på en annan kund. Vill du överföra ägandet?",
      "warning": "Denna åtgärd kommer att uppdatera fordonets registrerade ägare. Den tidigare ägaren kommer inte längre ha detta fordon kopplat till sitt konto.",
      "confirm": "Överför ägande",
      "noOwner": "Oregistrerad"
    },
    "draft": {
      "save": "Spara utkast",
      "saved": "Bokningsutkast sparat",
      "foundTitle": "Fortsätt utkast?",
      "foundDescription": "Du har en oavslutad bokning. Vill du fortsätta där du slutade eller börja om?",
      "continue": "Fortsätt utkast",
      "startNew": "Börja ny",
      "servicesCount": "tjänster",
      "savedAt": "Sparad"
    },
    "rentCarsDesc": "Tilldela valfritt ett lånefordon medan kundens bil servas",
    "addLoanCar": "Lägg till lånebil?",
    "addLoanCarDesc": "Erbjud ett lånefordon medan bilen är på service",
    "selectLoanCarLabel": "Välj lånebil",
    "startMileage": "Startmätarställning (km)",
    "noLoanCarsAvailable": "Inga lånebilar tillgängliga just nu",
    "noVariants": "Inga varianter tillgängliga för denna tjänst",
    "rentCar": "Hyrbil",
    "selectVariant": "Välj en variant",
    "tabs": {
      "services": "Tjänster",
      "packages": "Paket"
    },
    "searchPackages": "Sök paket...",
    "selectedPackages": "Valda paket",
    "noPackages": "Inga paket hittades",
    "packageVariant": "Variant",
    "variants": "varianter",
    "items": "objekt",
    "newBooking": "Ny bokning",
    "noAvailableCars": "Inga bilar tillgängliga för dessa datum",
    "noServices": "Inga tjänster hittades",
    "orderStatuses": {
      "preliminary": "Preliminär",
      "created": "Skapad",
      "inShop": "På verkstad",
      "startService": "Service startad",
      "pickedUp": "Hämtad",
      "finished": "Avslutad"
    },
    "loanerStatuses": {
      "available": "Tillgänglig",
      "onLoan": "Utlånad",
      "booked": "Bokad",
      "cleaning": "Rengöring"
    }
  },
  "scheduler": {
    "schedule": "Schema",
    "absence": "Frånvaro",
    "today": "Idag",
    "newBooking": "Ny bokning",
    "week": "Vecka",
    "previousWeek": "Föregående vecka",
    "nextWeek": "Nästa vecka",
    "day": "Dag",
    "month": "Månad",
    "vehicle": "Fordon",
    "bookings": "bokningar",
    "rows": "rader",
    "notAvailable": "Ej tillgänglig",
    "absenceManagement": "Frånvarohantering",
    "absenceDescription": "Hantera fordonstillgänglighet och schemalagt underhåll.",
    "date": "Datum",
    "selectDate": "Välj ett datum",
    "selectVehicle": "Välj ett fordon",
    "service": "Tjänst",
    "selectService": "Välj en tjänst",
    "time": "Tid",
    "selectTime": "Välj en tid",
    "notes": "Anteckningar",
    "notesPlaceholder": "Lägg till anteckningar för denna bokning...",
    "createBooking": "Skapa bokning",
    "fillAllFields": "Fyll i alla obligatoriska fält",
    "bookingCreated": "Bokning skapad framgångsrikt",
    "bookingError": "Ett fel uppstod när bokningen skapades",
    "newBookingDescription": "Schemalägg en ny servicetid",
    "noBookings": "Inga bokningar",
    "clickToBook": "Klicka för att boka",
    "noNote": "Ingen anteckning",
    "employeeColors": "Tekniker",
    "jobDetails": "Bokningsdetaljer",
    "serviceInfo": "Tjänsteinformation",
    "vehicleInfo": "Fordonsinformation",
    "customerInfo": "Kundinformation",
    "assignedTechnician": "Tilldelad tekniker",
    "hoursBooked": "{{booked}}h bokade av {{total}}h kapacitet",
    "overbooked": "⚠️ Dagen är överbokad!",
    "fullyBooked": "Dagen är fullbokad",
    "availableRentalCars": "Tillgängliga hyrbilar",
    "noRentalCarsAvailable": "Inga hyrbilar tillgängliga denna vecka",
    "customerVehicles": "Kundfordon",
    "loanerCarsFleet": "Lånebilsflotta",
    "availableLabel": "tillgängliga",
    "outLabel": "ute",
    "cleaningLabel": "städning",
    "vehiclesLabel": "Fordon",
    "loanersLabel": "Lånbilar",
    "daysLabel": "dagar",
    "confirmMove": "Bekräfta flytt av bokning",
    "confirmMoveDesc": "Flytta {{plate}} ({{service}}) till {{date}}{{time}}?",
    "vehicles": "fordon",
    "moveBooking": "Flytta bokning",
    "moveToDay": "Flytta till dag",
    "moveToTime": "Flytta till tid",
    "pickDate": "Välj ett datum",
    "updateBookingError": "Kunde inte uppdatera bokningen",
    "loadScheduleError": "Kunde inte ladda bokningsschemat",
    "loadScheduleErrorDesc": "Vi kunde inte ladda bokningar för vald period. Försök igen.",
    "dailyNotesUnavailable": "Dagens anteckningar är tillfälligt otillgängliga",
    "dailyNotesUnavailableDesc": "Bokningarna visas fortfarande, men anteckningarna för perioden kunde inte laddas.",
    "tabs": {
      "schedule": "Schema",
      "staffAttendance": "Personal & Närvaro",
      "checkInList": "Incheckningslista"
    },
    "checkInListPlaceholder": "Incheckningslista kommer snart",
    "loanersOut": "lånbilar ute",
    "noLoanerCars": "Inga lånbilar tillgängliga"
  },
  "kanban": {
    "statusTodo": "Att göra",
    "statusInProgress": "Pågående",
    "statusBlocked": "Blockerad",
    "statusDone": "Klart",
    "vehicle": "Fordon",
    "unassigned": "Ej tilldelad",
    "unassignedTooltip": "Dessa uppgifter behöver en tilldelad mekaniker",
    "focus": "Fokus",
    "focusTooltip": "Markera en specifik mekanikers uppgifter",
    "allMechanics": "Alla mekaniker",
    "dropHere": "Släpp här",
    "dropHereCross": "Flytta till detta fordon",
    "moveTask": "Flytta uppgift",
    "transferTask": "Överför uppgift",
    "moveTaskDesc": "Flytta \"{{task}}\" från {{from}} till {{to}}?",
    "timeline": "Tidslinje",
    "kanban": "Kanban",
    "tasks": "uppgifter",
    "dragTooltip": "Dra för att flytta mellan kolumner eller fordon",
    "columnTooltip": "{{status}} — släpp uppgifter här för att ändra status",
    "vehicleTooltip": "Fordon {{plate}}",
    "progressTooltip": "{{done}} av {{total}} uppgifter klara ({{percent}}%)",
    "addService": "Lägg till tjänst",
    "addServiceTooltip": "Lägg till en ny serviceuppgift för detta fordon",
    "vehicleNotes": "Fordonsanteckningar",
    "addServiceTitle": "Lägg till tjänst",
    "addServiceDesc": "Lägg till en ny tjänst till {{plate}}",
    "serviceName": "Tjänst",
    "selectService": "Välj en tjänst",
    "estimatedDuration": "Beräknad varaktighet",
    "assignMechanic": "Tilldela mekaniker",
    "variant": "Variant",
    "selectVariant": "Välj en variant",
    "variantRequired": "Vänligen välj en variant för denna tjänst",
    "noVariants": "Inga varianter tillgängliga för denna tjänst",
    "serviceNotes": "Anteckningar",
    "serviceNotesPlaceholder": "Lägg till speciella instruktioner eller anteckningar...",
    "quantity": "Antal",
    "quantityMin": "Antal måste vara minst 1",
    "mandatory": "Obligatorisk",
    "pricing": "Prissättning",
    "unitPrice": "Enhetspris",
    "specialPrice": "Specialpris",
    "specialPricePlaceholder": "Överskrid pris",
    "lineTotal": "Radsumma",
    "serviceAdded": "{{name}} tillagd",
    "vehicleCompleted": "Alla uppgifter för {{plate}} är klara!",
    "dragLocked": "Kan inte flytta tjänster när ordern är {{status}}",
    "allCompleted": "Alla fordon klara",
    "allCompletedDesc": "Alla schemalagda fordon har servats. Uppdaterar data...",
    "taskUpdateError": "Kunde inte uppdatera kanban-status",
    "noMatchingTasks": "Inga bokningar matchar filtret",
    "noMatchingTasksDesc": "Prova en annan orderstatus eller byt period.",
    "syntheticTask": "Bokning",
    "totalEstimatedTime": "Total beräknad arbetstid",
    "mechanicsActive": "mekaniker",
    "mechanicsActiveTooltip": "Antal mekaniker tilldelade till aktuella uppgifter",
    "totalOrderValue": "Totalt ordervärde för alla fordon",
    "orderStatus": "Orderstatus",
    "filterByStatus": "Filtrera efter status",
    "allStatuses": "Alla statusar",
    "estimatedPickup": "Ber. upphämtning",
    "editPickup": "Klicka för att redigera upphämtningstid",
    "pickupUpdated": "Upphämtningstid uppdaterad för {{plate}}",
    "orderStatuses": {
      "preliminary": "Preliminär",
      "created": "Skapad",
      "inShop": "I verkstaden",
      "startService": "Service startad",
      "pickedUp": "Upphämtad",
      "finished": "Klar"
    },
    "mandatoryService": "Obligatorisk tjänst"
  },
  "punchIn": {
    "title": "Daglig stämpling",
    "status": "Nuvarande status",
    "notPunchedIn": "Ej instämplad",
    "working": "Arbetar",
    "onBreak": "På rast",
    "todayWorkTime": "Dagens arbetstid",
    "punchIn": "Stämpla in",
    "punchOut": "Stämpla ut",
    "startBreak": "Starta rast",
    "endBreak": "Avsluta rast",
    "punchedInSuccess": "Du har stämplat in",
    "punchedOutSuccess": "Du har stämplat ut",
    "breakStarted": "Rast startad",
    "breakEnded": "Rast avslutad",
    "todayRecords": "Dagens registreringar",
    "teamStatus": "Teamstatus",
    "punchedIn": "instämplade",
    "enterSecurityPin": "Ange säkerhetskod",
    "enterPinDescription": "Ange din 4-siffriga PIN-kod för att bekräfta",
    "pinRequired": "Ange en 4-siffrig PIN-kod",
    "invalidPin": "Ogiltig PIN-kod. Försök igen.",
    "recordTypes": {
      "punch_in": "Instämpling",
      "punch_out": "Utstämpling",
      "break_start": "Raststart",
      "break_end": "Rastslut"
    }
  },
  "imageUpload": {
    "uploadImage": "Ladda upp bild",
    "changeImage": "Ändra bild",
    "removeImage": "Ta bort bild",
    "preview": "Bildförhandsvisning",
    "dragOrClick": "Dra och släpp eller klicka för att ladda upp",
    "dropHere": "Släpp bilden här",
    "maxSize": "Max {{size}}MB",
    "invalidType": "Ogiltig filtyp. Ladda upp en bild.",
    "tooLarge": "Filen är för stor. Maxstorlek är {{size}}MB."
  },
  "filters": {
    "title": "Filter",
    "clearAll": "Rensa alla",
    "sort": "Sortera",
    "sortBy": "Sortera efter",
    "columns": "Kolumner",
    "toggleColumns": "Växla kolumner",
    "export": "Exportera",
    "exportCSV": "Exportera som CSV",
    "exportExcel": "Exportera som Excel",
    "exportPDF": "Exportera som PDF",
    "print": "Skriv ut",
    "exportSuccess": "Exporterad som {{format}} framgångsrikt",
    "fields": "Fält",
    "toggleFields": "Växla synliga fält"
  },
  "leaves": {
    "title": "Ledighetshantering",
    "description": "Spåra och hantera ledighetsansökningar",
    "requestLeave": "Ansök om ledighet",
    "requestLeaveDesc": "Skicka in en ny ledighetsansökan för godkännande",
    "employee": "Anställd",
    "type": "Ledighetstyp",
    "dates": "Datum",
    "days": "Dagar",
    "daysLabel": "dagar",
    "reason": "Anledning",
    "reasonPlaceholder": "Ange anledningen till din ledighetsansökan",
    "selectDates": "Välj datum",
    "pending": "Väntande",
    "approved": "Godkänd",
    "rejected": "Nekad",
    "requestSubmitted": "Ledighetsansökan skickad",
    "searchPlaceholder": "Sök ledigheter...",
    "emptyMessage": "Inga ledighetsansökningar hittades",
    "ofTotal": "{{used}} använda av {{total}}",
    "types": {
      "annual": "Semester",
      "sick": "Sjukledighet",
      "personal": "Personlig ledighet",
      "unpaid": "Obetald ledighet",
      "vacation": "Semester",
      "parental": "Föräldraledighet",
      "vab": "VAB (sjukt barn)",
      "other": "Övrigt"
    },
    "startDate": "Startdatum",
    "endDate": "Slutdatum",
    "tabs": {
      "calendar": "Kalender",
      "absence": "Frånvaro"
    },
    "calendar": {
      "title": "Kalender",
      "subtitle": "Planera och schemalägg resurser",
      "team": "Team",
      "office": "Kontor",
      "searchEmployees": "Sök anställda...",
      "showingMine": "Mina ledigheter",
      "showingAll": "Alla anställda",
      "legend": {
        "vacation": "Semester",
        "sick": "Sjukledighet",
        "parental": "Föräldraledighet",
        "vab": "VAB (sjukt barn)",
        "unpaid": "Obetald ledighet",
        "pending": "Väntande"
      }
    },
    "register": {
      "title": "Ansök om ledighet",
      "user": "Användare",
      "selectUser": "Välj användare...",
      "absenceType": "Frånvarotyp",
      "selectType": "Välj typ...",
      "dateRange": "Datumintervall",
      "start": "Start",
      "end": "Slut",
      "partialDay": "Del av dag",
      "partialDayDesc": "Registrera frånvaro per timme",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "comment": "Kommentar (valfritt)",
      "commentPlaceholder": "Eventuella anteckningar...",
      "submit": "Ansök om ledighet",
      "saved": "Ledighetsansökan skickad",
      "missingFields": "Fyll i användare, typ och datum",
      "available": "Tillgängligt saldo",
      "requested": "Begärt",
      "days": "dagar",
      "insufficientBalance": "Otillräckligt saldo för denna ledighetstyp",
      "noBalanceTracking": "Ingen saldoberäkning för denna typ",
      "paid": "Betald",
      "unpaid": "Obetald",
      "requiresApproval": "Kräver godkännande",
      "autoApproved": "Godkänns automatiskt",
      "documentationRequired": "Underlag krävs",
      "noticeRequired": "Kräver {{days}} dagars förvarning",
      "insufficientNotice": "Inte tillräcklig förvarning för denna ledighetstyp"
    },
    "balance": {
      "vacation": "Semester",
      "sick": "Sjukdom",
      "vab": "VAB",
      "parental": "Föräldra",
      "remainingDays": "{{days}} dagar kvar"
    }
  },
  "workLogs": {
    "title": "Arbetstid",
    "description": "Spåra daglig arbetstid och aktiviteter",
    "addLog": "Lägg till arbetstid",
    "addLogDesc": "Logga din arbetstid för dagen",
    "employee": "Anställd",
    "date": "Datum",
    "time": "Tid",
    "hours": "Timmar",
    "clockIn": "Stämpla in",
    "clockOut": "Stämpla ut",
    "jobsCompleted": "Slutförda jobb",
    "notes": "Anteckningar",
    "notesPlaceholder": "Beskriv dina arbetsaktiviteter...",
    "today": "Idag",
    "employeesClocked": "Instämplade anställda",
    "totalHours": "Totala timmar",
    "logSubmitted": "Arbetstid registrerad",
    "searchPlaceholder": "Sök arbetstid...",
    "emptyMessage": "Ingen arbetstid hittades",
    "employees": "anställda",
    "selectEmployee": "Välj en anställd",
    "role": "Roll",
    "breakDuration": "Rast",
    "breakMin": "Rast (min)",
    "overtime": "Övertid",
    "overtimeTooltip": "Timmar utöver ordinarie schema",
    "efficiency": "Effektivitet",
    "avgEfficiency": "Snitteffektivitet",
    "jobs": "jobb",
    "yesterday": "igår",
    "thisWeek": "Denna vecka",
    "total": "totalt",
    "ongoing": "Pågående",
    "activeNow": "Aktiva nu",
    "allStatuses": "Alla statusar",
    "statusCompleted": "Slutförd",
    "statusInProgress": "Pågående",
    "statusOnBreak": "På rast",
    "statusAbsent": "Frånvarande"
  },
  "billing": {
    "title": "Fakturering",
    "description": "Hantera fakturor och spåra betalningar",
    "createInvoice": "Skapa faktura",
    "createInvoiceDesc": "Skapa en ny faktura för en kund",
    "customer": "Kund",
    "selectCustomer": "Välj en kund",
    "invoiceNumber": "Faktura #",
    "amount": "Belopp",
    "dueDate": "Förfallodatum",
    "notes": "Anteckningar",
    "notesPlaceholder": "Lägg till anteckningar för denna faktura...",
    "draft": "Utkast",
    "sent": "Skickad",
    "paid": "Betald",
    "late": "Förfallen",
    "totalRevenue": "Total intäkt",
    "pendingPayments": "Väntande betalningar",
    "overdueAmount": "Förfallet belopp",
    "totalInvoices": "Totala fakturor",
    "invoiceSent": "Faktura skickad",
    "invoiceCreated": "Faktura skapad",
    "downloaded": "Faktura nedladdad",
    "searchPlaceholder": "Sök fakturor...",
    "emptyMessage": "Inga fakturor hittades",
    "tabs": {
      "overview": "Översikt",
      "invoicing": "Fakturering",
      "supplierInvoices": "Leverantörsfakturor",
      "timesheets": "Tidrapporter"
    },
    "customerVehicleTitle": "Kund & fordon",
    "searchCustomerOrVehicle": "Sök på namn, e-post, telefon, reg.nummer eller modell…",
    "customersGroup": "Kunder",
    "vehiclesGroup": "Fordon",
    "noResults": "Inga resultat hittades.",
    "selectedCustomer": "Kund",
    "selectedVehicle": "Fordon",
    "noCustomerSelected": "Ingen kund vald",
    "noVehicleSelected": "Inget fordon valt",
    "pickVehicleHint": "Valfritt — välj bland kundens fordon nedan",
    "clearSelection": "Rensa",
    "invoiceDetails": "Fakturadetaljer",
    "invoiceType": "Fakturatyp",
    "invoiceTypePlaceholder": "Välj en fakturatyp",
    "billTypeOptions": {
      "bill": "Faktura",
      "creditBill": "Kreditfaktura",
      "cashBill": "Kontantfaktura",
      "collectiveInvoice": "Samlingsfaktura"
    },
    "status": "Status",
    "currency": "Valuta",
    "billingDate": "Faktureringsdatum",
    "paymentDate": "Betalningsdatum",
    "paymentDays": "Betalningsdagar",
    "bookedBy": "Bokad av",
    "bookedByPlaceholder": "Bokare-ID",
    "comments": "Kommentarer",
    "commentsPlaceholder": "Ytterligare faktureringskommentarer…",
    "driverInformation": "Kundinformation",
    "driverIDLabel": "Kund-ID",
    "driverIDPlaceholder": "Kund-UUID",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "email": "E-post",
    "phoneNumber": "Telefonnummer",
    "address": "Adress",
    "zipCode": "Postnummer",
    "city": "Stad",
    "country": "Land",
    "driverHasCard": "Kunden har kort",
    "cardNumber": "Kortnummer",
    "cardValidTo": "Kort giltigt till",
    "keyNumber": "Nyckelnummer",
    "companyReferenceTitle": "Företag & referens",
    "companyOrgNumber": "Företagets org.nummer",
    "companyReference": "Företagsreferens",
    "driverExternalNumber": "Kundens externa nummer",
    "ordersSectionTitle": "Ordrar",
    "searchOrders": "Sök ordrar på nummer…",
    "selectCustomerForOrders": "Välj en kund för att se dess ordrar",
    "added": "Tillagd",
    "currencyMismatch": "{{currency}} skiljer sig från fakturan",
    "noOrdersFound": "Inga matchande ordrar.",
    "noOrdersAttached": "Inga ordrar kopplade.",
    "services": "Tjänster",
    "products": "Produkter",
    "viewBreakdown": "Visa uppdelning",
    "hideBreakdown": "Dölj uppdelning",
    "miscItems": "Övriga rader",
    "addItem": "Lägg till rad",
    "noMiscItems": "Inga övriga rader.",
    "miscDescription": "Beskrivning",
    "miscQty": "Antal",
    "miscPrice": "Pris",
    "miscDiscount": "Rabatt",
    "miscVat": "Moms %",
    "miscTotal": "Totalt",
    "removeItem": "Ta bort rad",
    "summary": "Sammanfattning",
    "subtotal": "Delsumma",
    "discount": "Rabatt",
    "vat": "Moms",
    "total": "Totalt",
    "billedAmountOverride": "Fakturerat belopp (override)",
    "billedAmount": "Fakturerat belopp",
    "newInvoice": "Ny faktura",
    "newInvoiceDescription": "Skapa en ny faktura genom att fylla i förar-, företags- och faktureringsuppgifter.",
    "saveAsDraft": "Spara som utkast",
    "invoiceSavedDraft": "Fakturan sparad som utkast",
    "pleaseFillForm": "Fyll i formuläret",
    "bookedByRequired": "Bokad av krävs",
    "invoiceSaved": "Fakturan sparad",
    "invoiceNotFound": "Fakturan hittades inte",
    "invoiceUpdated": "Fakturan uppdaterad",
    "smsNotificationSent": "SMS-avisering skickad",
    "emailNotificationSent": "E-postavisering skickad",
    "notifySms": "Avisera SMS",
    "notifyEmail": "Avisera e-post",
    "invoiceWithId": "Faktura {{id}}",
    "driver": "Förare",
    "statusAll": "Alla",
    "statusSent": "Skickad"
  },
  "products": {
    "title": "Produkter & Lager",
    "description": "Hantera din produktkatalog och lagernivåer",
    "addProduct": "Lägg till produkt",
    "addProductDesc": "Lägg till en ny produkt i ditt lager",
    "name": "Produktnamn",
    "namePlaceholder": "t.ex. Motorolja 5W-30",
    "sku": "Artikelnummer",
    "category": "Kategori",
    "selectCategory": "Välj kategori",
    "price": "Försäljningspris",
    "cost": "Inköpspris",
    "margin": "Marginal",
    "stock": "Lager",
    "reorderLevel": "Beställningspunkt",
    "inStock": "I lager",
    "lowStock": "Lågt lager",
    "outOfStock": "Slut i lager",
    "totalProducts": "Totala produkter",
    "inventoryValue": "Lagervärde",
    "totalStock": "Totalt lagerantal",
    "productAdded": "Produkt tillagd",
    "searchPlaceholder": "Sök produkter...",
    "emptyMessage": "Inga produkter hittades",
    "categories": {
      "accessories": "Tillbehör",
      "brakes": "Bromsar",
      "engine": "Motor",
      "filters": "Filter",
      "oils": "Oljor"
    },
    "form": {
      "basicInfo": "Grundl?ggande information",
      "basicInfoDesc": "L?gg till grunduppgifter f?r denna produkt",
      "costDesc": "Ink?pskostnad f?re p?slag",
      "descriptionPlaceholder": "Beskriv produkten",
      "inventory": "Lagerinformation",
      "location": "Lagerplats",
      "locationDesc": "Var denna produkt f?rvaras",
      "locationPlaceholder": "t.ex. Hylla A3",
      "notesPlaceholder": "L?gg till produktanteckningar...",
      "pricing": "Prisuppgifter",
      "productImage": "Produktbild",
      "reorderLevelDesc": "Minsta lagerniv? innan ny best?llning",
      "supplier": "Leverant?r",
      "supplierPlaceholder": "Ange leverant?rsnamn"
    },
    "productUpdated": "Produkten uppdaterades",
    "productDeleted": "Produkten raderades",
    "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras.",
    "currency": "Valuta",
    "externalArticleNumber": "Externt artikelnummer",
    "storeForInventory": "Butik för lager",
    "selectCategory": "Välj en kategori",
    "selectStore": "Välj en butik",
    "updateRelatedData": "Uppdatera relaterad data",
    "required": "Obligatoriskt",
    "basicInfo": "Grundläggande information",
    "itemNumber": "Artikelnummer",
    "type": "Typ",
    "typeLocal": "Lokal",
    "typeGlobal": "Global",
    "formDescription": "Beskrivning",
    "categoryId": "Kategori-ID",
    "pricingTitle": "Prissättning",
    "priceAward": "Pris",
    "inventoryTitle": "Lager",
    "inventoryBalance": "Lagersaldo",
    "storeId": "Butiks-ID",
    "supplierRefTitle": "Leverantör & referenser",
    "supplierArticleNumber": "Leverantörens artikelnummer",
    "updateRelatedDataDesc": "Uppdatera automatiskt relaterade poster när denna produkt ändras"
  },
  "rentalFleet": {
    "title": "Hyresflotta",
    "description": "Hantera din hyresfordonsflotta",
    "addVehicle": "Lägg till fordon",
    "addVehicleDesc": "Lägg till ett nytt fordon i hyresflottan",
    "vehicle": "Fordon",
    "vehiclePlaceholder": "t.ex. Toyota Corolla 2024",
    "licensePlate": "Registreringsnummer",
    "mileage": "Mätarställning",
    "customer": "Kund",
    "selectCustomer": "Välj kund",
    "rentalPeriod": "Hyresperiod",
    "startDate": "Startdatum",
    "expectedReturn": "Förväntat återlämning",
    "available": "Tillgänglig",
    "unavailable": "Otillg?nglig",
    "onLoan": "Uthyrd",
    "maintenance": "Under underhåll",
    "blacklisted": "Svartlistad",
    "totalVehicles": "Totala fordon",
    "assign": "Tilldela",
    "return": "Återlämna",
    "assignCar": "Tilldela fordon",
    "vehicleAdded": "Fordon tillagt",
    "vehicleUpdated": "Fordon uppdaterat",
    "vehicleAssigned": "Fordon tilldelat kund",
    "vehicleReturned": "Fordon återlämnat",
    "searchPlaceholder": "Sök hyresflotta...",
    "emptyMessage": "Inga hyresfordon hittades",
    "vehicleInfo": "Fordonsinformation",
    "rentalInfo": "Hyresinformation",
    "fillRequired": "Vänligen fyll i obligatoriska fält",
    "rentCarHistory": "Uthyrningshistorik",
    "noRentCarHistory": "Ingen uthyrningshistorik f?r detta fordon",
    "carNumber": "Bilnummer",
    "notesTitle": "Anteckningar",
    "required": "Obligatoriskt",
    "history": {
      "orderId": "Order-ID",
      "bookedBy": "Bokad av",
      "start": "Start",
      "end": "Slut",
      "created": "Skapad",
      "active": "Aktiv",
      "completed": "Avslutad",
      "cancelled": "Avbokad"
    },
    "form": {
      "registrationNumber": "Registreringsnummer",
      "vehicleNumber": "Fordonsnummer",
      "brand": "M?rke",
      "model": "Modell",
      "year": "?r",
      "mileage": "M?tarst?llning",
      "color": "F?rg",
      "additionalInfo": "Ytterligare information",
      "notes": "Anteckningar",
      "notesPlaceholder": "Information om detta fordon...",
      "status": "Status",
      "rentCarStatus": "Uthyrningsstatus",
      "rentVehicleAdded": "Fordon tillagt i hyresflottan"
    },
    "rentVehicleAdded": "Fordon tillagt i hyresflottan",
    "deleteConfirm": "Är du säker på att du vill ta bort {{name}}? Åtgärden kan inte ångras."
  },
  "campaigns": {
    "title": "Kampanjer",
    "description": "Skapa och hantera marknadsföringskampanjer",
    "createCampaign": "Skapa kampanj",
    "createCampaignDesc": "Skapa en ny marknadsföringskampanj",
    "name": "Kampanjnamn",
    "namePlaceholder": "t.ex. Vinterservice-erbjudande",
    "type": "Typ",
    "email": "E-post",
    "sms": "SMS",
    "promotion": "Kampanj",
    "audience": "Målgrupp",
    "selectAudience": "Välj målgrupp",
    "message": "Meddelande",
    "messagePlaceholder": "Skriv ditt kampanjmeddelande...",
    "draft": "Utkast",
    "scheduled": "Schemalagd",
    "active": "Aktiv",
    "completed": "Slutförd",
    "sent": "Skickad",
    "send": "Skicka",
    "performance": "Resultat",
    "openRate": "Öppningsfrekvens",
    "clickRate": "Klickfrekvens",
    "totalCampaigns": "Totala kampanjer",
    "totalSent": "Totalt skickade meddelanden",
    "avgOpenRate": "Snitt öppningsfrekvens",
    "avgClickRate": "Snitt klickfrekvens",
    "allCampaigns": "Alla kampanjer",
    "customerSegments": "Kundsegment",
    "customers": "kunder",
    "targetSegment": "Rikta in detta segment",
    "campaignCreated": "Kampanj skapad",
    "campaignSent": "Kampanj skickad",
    "searchPlaceholder": "Sök kampanjer...",
    "emptyMessage": "Inga kampanjer hittades"
  },
  "integrations": {
    "title": "Integrationer",
    "description": "Anslut dina favoritverktyg och tjänster",
    "totalIntegrations": "Totala integrationer",
    "connected": "Anslutna",
    "available": "Tillgängliga",
    "configure": "Konfigurera",
    "configureDesc": "Uppdatera inställningarna för denna integration",
    "apiKey": "API-nyckel",
    "webhookUrl": "Webhook-URL",
    "webhookUrlPlaceholder": "https://...",
    "configSaved": "Konfiguration sparad",
    "categories": {
      "payment": "Betalningar",
      "communication": "Kommunikation",
      "calendar": "Kalender",
      "accounting": "Bokföring"
    },
    "disconnected": "Frånkopplad"
  },
  "companies": {
    "addCompany": "Lägg till företag",
    "addCompanyDesc": "Lägg till ett nytt företag i databasen",
    "companyAdded": "Företag tillagt",
    "form": {
      "companyInfo": "Företagsinformation",
      "companyInfoDesc": "Ange företagsuppgifterna",
      "companyNumber": "Företagsnummer",
      "addressInfo": "Adressinformation",
      "addressInfoDesc": "Ange företagets fysiska adress",
      "billingInfo": "Faktureringsinformation",
      "billingInfoDesc": "Konfigurera faktureringsinställningar",
      "billingEmail": "Faktureringsmail",
      "billingEmailDesc": "Separat e-post för fakturor",
      "paymentTerms": "Betalningsvillkor (dagar)",
      "paymentTermsDesc": "Antal dagar tills betalning förfaller",
      "drivers": "Kontaktpersoner",
      "driversDesc": "Lägg till kontaktpersoner kopplade till detta företag",
      "addDriver": "Lägg till kontakt",
      "driver": "Kontakt",
      "notes": "Anteckningar",
      "sharedNotes": "Delade anteckningar",
      "sharedNotesPlaceholder": "Anteckningar synliga för all personal...",
      "sharedNotesDesc": "Dessa anteckningar är synliga för all personal",
      "internalNotes": "Interna anteckningar",
      "internalNotesPlaceholder": "Privata anteckningar...",
      "internalNotesDesc": "Dessa anteckningar är endast synliga för ledningen",
      "driverInfo": "Primär förare / kontakt",
      "driverInfoDesc": "Sök en befintlig kund för att förifyll, eller fyll i formuläret för en ny förare.",
      "searchCustomerPlaceholder": "Sök befintliga kunder för att förifyll…"
    },
    "companyUpdated": "Företaget uppdaterades"
  },
  "categories": {
    "title": "Kategorier",
    "createCategory": "Skapa kategori",
    "tabs": {
      "service": "Tjänstkategorier",
      "product": "Produktkategorier"
    },
    "searchPlaceholder": "Sök kategorier...",
    "addServiceCategory": "Lägg till tjänstkategori",
    "addProductCategory": "Lägg till produktkategori",
    "serviceCategories": "Tjänstkategorier",
    "productCategories": "Produktkategorier",
    "serviceCategory": "Tjänstkategori",
    "productCategory": "Produktkategori",
    "serviceCount": "Tjänster",
    "productCount": "Produkter",
    "services": "tjänster",
    "products": "produkter",
    "color": "Färg",
    "details": "Kategoriuppgifter",
    "overview": "Översikt",
    "createdAt": "Skapad",
    "updatedAt": "Uppdaterad",
    "namePlaceholder": "Ange kategorinamn",
    "descriptionPlaceholder": "Ange kategoribeskrivning",
    "nameRequired": "Kategorinamn krävs",
    "savedSuccess": "Kategori sparad",
    "deletedSuccess": "Kategori borttagen",
    "createdSuccess": "Kategori skapad",
    "emptyServiceCategories": "Inga tjänstkategorier hittades",
    "emptyProductCategories": "Inga produktkategorier hittades",
    "image": "Kategoribild",
    "all": "Alla",
    "serviceDeleteConfirm": "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras.",
    "productDeleteConfirm": "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras."
  },
  "tooltips": {
    "sidebar": {
      "expand": "Expandera sidopanelen",
      "collapse": "Minimera sidopanelen"
    },
    "nav": {
      "booking": "Hantera bokningar och tidsbokning",
      "customers": "Visa och hantera kundregister",
      "vehicles": "Spåra registrerade fordon",
      "services": "Bläddra och hantera tjänstekatalog",
      "jobs": "Spåra arbetsordrar och jobb",
      "leaves": "Hantera personalens ledighetsansökningar",
      "workLogs": "Övervaka daglig arbetstid",
      "billing": "Hantera fakturor och betalningar",
      "products": "Visa produktlager",
      "categories": "Hantera tjänst- och produktkategorier",
      "rentalFleet": "Hantera hyresfordonsflotta",
      "campaigns": "Skapa marknadsföringskampanjer",
      "communication": "Hantera e-post- och SMS-mallar",
      "settings": "Systeminställningar och konfiguration",
      "myWork": "Din personliga arbetslogg och ledigheter",
      "myWorkspace": "Din personliga ERP: ledigheter, tidrapporter, övertid, översikt",
      "teamOverview": "Hantera ditt team: status, godkännanden, kalender"
    },
    "topbar": {
      "search": "Sök efter registreringsnummer",
      "store": "Växla mellan butiksplatser",
      "notifications": "Visa senaste notifikationer",
      "userMenu": "Kontoinställningar och preferenser"
    },
    "quickActions": {
      "newCustomer": "Registrera en ny kund i systemet",
      "addVehicle": "Lägg till ett nytt fordon i registret",
      "createJob": "Skapa en ny arbetsorder",
      "newService": "Lägg till en ny tjänst i katalogen"
    },
    "viewSwitcher": {
      "cards": "Visa objekt som kort",
      "list": "Visa objekt i en tabell"
    },
    "filters": {
      "clearSearch": "Rensa sökfältet",
      "filter": "Tillämpa filter för att begränsa resultat",
      "sort": "Ändra sorteringsordning",
      "columns": "Växla synliga kolumner",
      "export": "Exportera data till fil",
      "print": "Skriv ut aktuell vy"
    }
  },
  "tour": {
    "title": "Välkomstguide",
    "stepOf": "Steg {{current}} av {{total}}",
    "skip": "Hoppa över",
    "next": "Nästa",
    "prev": "Tillbaka",
    "finish": "Uppfattat!",
    "steps": {
      "logo": {
        "title": "Välkommen till Care of Cars!",
        "description": "Klicka på logotypen när som helst för att återgå till din instrumentpanel. Det här är din hembas för att hantera allt."
      },
      "sidebarNav": {
        "title": "Navigationsmeny",
        "description": "Gå till alla moduler här — Bokningar, Kunder, Fordon, Tjänster, Jobb och mer. Sidofältet fälls ihop automatiskt på inställningssidor och kan växlas manuellt."
      },
      "pageTitle": {
        "title": "Sidtitel & Kontext",
        "description": "Det här området visar aktuellt sidnamn och en hjälpsam undertext som beskriver vad du kan göra här."
      },
      "search": {
        "title": "Snabbsökning",
        "description": "Sök bland fordon, kunder och bokningar direkt. Skriv ett registreringsnummer eller kundnamn för att hoppa direkt till resultaten."
      },
      "store": {
        "title": "Butiksväljare",
        "description": "Om du hanterar flera filialer eller platser, växla mellan dem här. Dina data och inställningar är kopplade till den aktiva butiken."
      },
      "howTo": {
        "title": "Användarguide",
        "description": "Klicka på denna knapp när som helst för att spela om den guidade turen och lära dig om varje del av gränssnittet."
      },
      "userMenu": {
        "title": "Ditt Konto",
        "description": "Gå till din profil, inställningar, språkpreferenser och organisationsväxlare. Du kan också logga ut härifrån."
      },
      "mainContent": {
        "title": "Huvudarbetsyta",
        "description": "Det är här allt händer! Varje sida visar relevant data, formulär och verktyg. Utforska sidofältet för att upptäcka alla tillgängliga moduler."
      },
      "bookingModeToggle": {
        "title": "Tidslinje vs Kanban",
        "description": "Växla mellan tidslinjen och Kanban-vyn. Tidslinjen visar ett Gantt-schema med dag/vecka/månad. Kanban organiserar bokningar i statuskolumner för snabb arbetsflödeshantering."
      },
      "bookingViewTabs": {
        "title": "Dag / Vecka / Månad",
        "description": "I tidslinjeläge kan du växla mellan dag-, vecko- och månadsvy. Dagvy visar tidsslottar, veckovy visar ett 7-dagars Gantt-schema, och månadsvy ger en översikt."
      },
      "bookingNavControls": {
        "title": "Navigera datum",
        "description": "Använd pilarna för att flytta framåt eller bakåt i datum. Etiketten visar aktuell period. Klicka på 'Idag' för att hoppa tillbaka till aktuellt datum."
      },
      "bookingNewBtn": {
        "title": "Skapa en bokning",
        "description": "Klicka här för att skapa en ny bokning. Du kan också dra och släppa befintliga bokningar mellan datum eller statuskolumner för att boka om eller uppdatera deras status."
      },
      "bookingDragDrop": {
        "title": "Dra & släpp bokningar",
        "description": "Ta tag i en bokningsfält och dra den till en annan dagkolumn (veckovy) eller tidsslot (dagvy) för att boka om. En markerad släppzon visar var den hamnar, och du får bekräfta innan flytten genomförs."
      },
      "dayTimeHeader": {
        "title": "Tidsluckor",
        "description": "Översta raden visar tidsluckor per timme. Klicka på en lucka för att skapa en ny bokning, eller släpp en dragen bokning på en lucka för att boka om den."
      },
      "dayVehicleRow": {
        "title": "Fordonstidslinje",
        "description": "Varje rad representerar ett fordon med bokningar som färgade fält. Dra ett fält åt vänster eller höger för att flytta det till en annan tidslucka."
      },
      "newBookingSteps": {
        "title": "Steg-för-steg guide",
        "description": "Bokningsflödet är uppdelat i fem steg: Kund och fordon, Boka tid, Tjänster, Hyrbil och Bekräfta. Klicka på valfritt slutfört steg för att gå tillbaka och redigera."
      },
      "newBookingCustomerTab": {
        "title": "Kund eller fordon först",
        "description": "Börja med att söka efter en kund eller byt till 'Per fordon' för att söka efter registreringsnummer. Att välja en kopplar automatiskt den andra. Om den inte hittas, använd 'Lägg till ny'."
      },
      "newBookingServices": {
        "title": "Välj tjänster",
        "description": "Bläddra och filtrera tjänster efter kategori. Klicka på en tjänst för att tilldela mekaniker, ange antal, specialpris och anteckningar. Valda tjänster visas i sammanfattningen."
      },
      "newBookingSchedule": {
        "title": "Schedule & Loan Car",
        "description": "Välj intags- och leveransdatum/-tider. Markera som preliminärt om det är preliminärt och lägg till bokningsanteckningar från kunden."
      },
      "newBookingRentCar": {
        "title": "lånebil",
        "description": "Växla hyrbilsknappen för att tilldela ett servicefordon med startkörsträckaregistrering."
      },
      "newBookingConfirm": {
        "title": "Granska & bekräfta",
        "description": "Granska alla detaljer, justera momsfri-växeln eller rabattprocent, och bekräfta. Använd utskriftsknappen för att skapa en sammanfattning. Ditt utkast sparas automatiskt."
      },
      "newBookingNav": {
        "title": "Navigeringskontroller",
        "description": "Använd Tillbaka/Nästa för att flytta mellan steg. Nästa-knappen är inaktiverad tills obligatoriska fält är ifyllda. I sista steget, klicka Bekräfta för att skapa bokningen."
      }
    },
    "pages": {
      "dashboard": {
        "header": {
          "title": "Din instrumentpanel",
          "description": "Detta är din startsida. Sidtitel och KPI:er sammanfattar dagens aktivitet."
        },
        "main": {
          "title": "Dagens översikt",
          "description": "Följ dagens intäkter, bokningar, personal på pass och tjänster. Lagervarningar och veckonoteringar visas också här."
        }
      },
      "customers": {
        "header": {
          "title": "Kunder",
          "description": "Hantera privat- och företagskunder. Lägg till nya kunder och se deras fordon och bokningshistorik."
        },
        "main": {
          "title": "Kundlista",
          "description": "Filtrera, sök och exportera kunder. Klicka på en rad för en 360°-profil med fordon, bokningar och fakturor."
        }
      },
      "vehicles": {
        "header": {
          "title": "Fordon",
          "description": "Alla fordon registrerade i verkstaden. Lägg till nya fordon via registreringsnummer."
        },
        "main": {
          "title": "Fordonslista",
          "description": "Använd filter och sök för att hitta fordon snabbt. Öppna ett fordon för ägare, servicehistorik och kommande bokningar."
        }
      },
      "jobs": {
        "header": {
          "title": "Jobb",
          "description": "Aktiva och slutförda servicejobb i verkstaden."
        },
        "main": {
          "title": "Jobbhantering",
          "description": "Använd 'Skapa jobb' för att starta en ny bokning. Följ status, tilldelade mekaniker och kopplade fakturor."
        }
      },
      "newBooking": {
        "rentcars": {
          "title": "Låne-/Hyrbil",
          "description": "Tilldela vid behov en hyrbil eller lånebil till bokningen. Tillgängligheten kontrolleras mot din uthyrningsflotta."
        }
      },
      "pricing": {
        "header": {
          "title": "Prissättning",
          "description": "Centrala prisregler för tjänster, paket och tillägg."
        },
        "main": {
          "title": "Prisregler",
          "description": "Justera standardpriser, rabatter och specialpriser. Ändringar gäller alla nya bokningar och fakturor."
        }
      },
      "myWorkspace": {
        "header": {
          "title": "Min arbetsyta",
          "description": "Din personliga hub: stämpla in/ut, arbetsloggar, ledigheter och tilldelade jobb."
        },
        "main": {
          "title": "Personlig översikt",
          "description": "Växla mellan flikar för att se dagens pass, logga tid, ansöka om ledighet eller se din jobbkö."
        }
      },
      "teamOverview": {
        "header": {
          "title": "Teamöversikt",
          "description": "Realtidsöversikt av teamet — vem som är instämplad, på rast, ledig eller off duty."
        },
        "main": {
          "title": "Teamstatus",
          "description": "Live-tavla med närvaro, arbetsloggar och team-KPI:er. Filtrera per butik eller roll."
        }
      },
      "invoicing": {
        "header": {
          "title": "Fakturering",
          "description": "Skapa och hantera fakturor, offerter och kreditnotor för slutförda jobb."
        },
        "main": {
          "title": "Fakturalista",
          "description": "Filtrera per status. Öppna en faktura för att se rader, skriva ut, e-posta eller markera som betald."
        }
      },
      "economy": {
        "header": {
          "title": "Ekonomi",
          "description": "Ekonomisk översikt — intäkter, kostnader, vinst och momsrapporter."
        },
        "main": {
          "title": "Ekonomirapporter",
          "description": "Detaljerade periodrapporter, exportera siffror och stäm av mot din bokföring."
        }
      },
      "products": {
        "header": {
          "title": "Produkter",
          "description": "Delar och produkter som används vid service."
        },
        "main": {
          "title": "Produktkatalog",
          "description": "Hantera lager, leverantörsinfo och priser. Lågt lager utlöser varningar på instrumentpanelen."
        }
      },
      "rentalFleet": {
        "header": {
          "title": "Uthyrningsflotta",
          "description": "Låne- och hyrbilar tillgängliga för kunder vid service."
        },
        "main": {
          "title": "Flotthantering",
          "description": "Spåra tillgänglighet, nuvarande hyresgäst och uthyrningshistorik per fordon."
        }
      },
      "campaigns": {
        "header": {
          "title": "Kampanjer",
          "description": "Marknadsföringskampanjer och kundkommunikation."
        },
        "main": {
          "title": "Kampanjlista",
          "description": "Skapa nya kampanjer, rikta kundsegment och följ engagemangsdata."
        }
      },
      "account": {
        "header": {
          "title": "Mitt konto",
          "description": "Profil, säkerhet och inloggningshistorik för din användare."
        },
        "main": {
          "title": "Kontouppgifter",
          "description": "Uppdatera personlig info, byt lösenord, hantera 2FA och se senaste inloggningar."
        }
      },
      "settings": {
        "header": {
          "title": "Inställningar",
          "description": "Verkstadsövergripande konfiguration — butik, personal, tjänster, arbetstider, integrationer m.m."
        },
        "main": {
          "title": "Inställningssektioner",
          "description": "Använd sidnavigeringen för att hoppa mellan sektioner. Ändringar gäller aktiv butik om inget annat anges."
        }
      }
    }
  },
  "communication": {
    "tabs": {
      "email": "E-postmallar",
      "sms": "SMS-mallar"
    },
    "searchPlaceholder": "Sök mallar...",
    "addEmailTemplate": "Ny e-postmall",
    "addSmsTemplate": "Ny SMS-mall",
    "newEmailTemplate": "Ny e-postmall",
    "newSmsTemplate": "Ny SMS-mall",
    "editEmailTemplate": "Redigera e-postmall",
    "editSmsTemplate": "Redigera SMS-mall",
    "templateDetails": "Malldetaljer",
    "templateCreated": "Mall skapad",
    "templateUpdated": "Mall uppdaterad",
    "templateDeleted": "Mall borttagen",
    "noTemplates": "Inga mallar hittades",
    "dynamicVariables": "Dynamiska variabler",
    "variablesHelp": "Klicka på en variabel för att infoga den i mallens brödtext",
    "usedVariables": "Använda",
    "variables": {
      "categories": {
        "customer": "Kund",
        "vehicle": "Fordon",
        "booking": "Bokning",
        "services": "Tjänster",
        "products": "Produkter",
        "rentCar": "Hyrbil",
        "employee": "Anställd",
        "store": "Butik / Filial",
        "invoice": "Faktura & Marknadsföring"
      },
      "customer_first_name": "Förnamn",
      "customer_last_name": "Efternamn",
      "customer_full_name": "Fullständigt namn",
      "customer_email": "E-post",
      "customer_phone": "Telefon",
      "customer_address": "Adress",
      "customer_zip_code": "Postnummer",
      "customer_city": "Stad",
      "customer_country": "Land",
      "vehicle_reg": "Registreringsnummer",
      "vehicle_brand": "Märke",
      "vehicle_model": "Modell",
      "vehicle_color": "Färg",
      "vehicle_year": "År",
      "vehicle_fuel_type": "Bränsletyp",
      "vehicle_gear_type": "Växellåda",
      "vehicle_mileage": "Mätarställning",
      "vehicle_type": "Fordonstyp",
      "booking_ref": "Bokningsreferens",
      "booking_date": "Bokningsdatum",
      "booking_time": "Bokningstid",
      "pickup_date": "Upphämtningsdatum",
      "pickup_time": "Upphämtningstid",
      "booking_status": "Bokningsstatus",
      "booking_notes": "Bokningsanteckningar",
      "total_amount": "Totalbelopp",
      "currency": "Valuta",
      "discount": "Rabatt",
      "service_list": "Tjänstelista",
      "service_name": "Tjänstnamn",
      "service_cost": "Tjänstkostnad",
      "service_currency": "Tjänstvaluta",
      "product_list": "Produktlista",
      "product_description": "Produktbeskrivning",
      "product_total": "Produkttotal",
      "rent_car_reg": "Hyrbilsregistrering",
      "rent_car_start": "Hyrstartdatum",
      "rent_car_end": "Hyrslutdatum",
      "rent_car_status": "Hyrstatus",
      "employee_full_name": "Anställds fullständiga namn",
      "employee_first_name": "Anställds förnamn",
      "employee_last_name": "Anställds efternamn",
      "store_name": "Butiksnamn",
      "store_phone": "Butikstelefon",
      "store_email": "Butikse-post",
      "store_address": "Butiksadress",
      "store_city": "Butiksstad",
      "store_zip_code": "Butikspostnummer",
      "store_country": "Butiksland",
      "store_website": "Butikswebbplats",
      "store_org_number": "Organisationsnummer",
      "store_vat_number": "Momsregistreringsnummer",
      "store_contact_person": "Kontaktperson",
      "store_bankgiro": "Bankgiro",
      "store_plusgiro": "Plusgiro",
      "store_payment_days": "Betalningsdagar",
      "invoice_number": "Fakturanummer",
      "promo_code": "Kampanjkod",
      "feedback_link": "Feedbacklänk"
    },
    "chars": "tecken",
    "segments": "segment",
    "multipleSegments": "Detta meddelande skickas som flera segment",
    "preview": {
      "to": "Till:",
      "emailFooter": "Avprenumerera",
      "businessSms": "Företagsmeddelande"
    },
    "livePreview": "Liveförhandsgranskning",
    "previewEmpty": "Börja skriva för att se en förhandsgranskning...",
    "noSubject": "Inget ämne angivet",
    "segment": "segment",
    "deleteConfirm": "Ta bort denna mall?",
    "deleteDescription": "Denna åtgärd kan inte ångras. Mallen kommer att tas bort permanent.",
    "fields": {
      "name": "Malltitel",
      "templateName": "Mallnamn",
      "subject": "Ämnesrad",
      "body": "E-postinnehåll",
      "message": "Meddelande",
      "content": "Innehåll",
      "category": "Kategori",
      "variables": "Variabler"
    },
    "placeholders": {
      "name": "t.ex. Bokningsbekräftelse",
      "templateName": "t.ex. bokningsbekraftelse",
      "subject": "t.ex. Din bokning {{booking_ref}} är bekräftad",
      "emailBody": "Skriv ditt e-post HTML-innehåll här...",
      "smsBody": "Skriv ditt SMS-meddelande här..."
    },
    "category": {
      "transactional": "Transaktionell",
      "marketing": "Marknadsföring",
      "notification": "Avisering",
      "reminder": "Påminnelse"
    },
    "errors": {
      "nameRequired": "Mallnamn krävs",
      "subjectRequired": "Ämnesrad krävs",
      "bodyRequired": "Mallinnehåll krävs"
    },
    "variableGroups": {
      "customer": "Kund",
      "vehicle": "Fordon",
      "booking": "Bokning",
      "services": "Tjänster",
      "invoice": "Faktura",
      "store": "Butik",
      "company": "Företag",
      "employee": "Anställd",
      "rentalCar": "Hyrbil",
      "other": "Övrigt"
    }
  },
  "variants": {
    "title": "Tjänstvarianter",
    "description": "Hantera pris- och schemaläggningsvarianter för denna tjänst",
    "addVariant": "Lägg till variant",
    "editVariant": "Redigera variant",
    "deleteTitle": "Ta bort variant",
    "deleteDesc": "Är du säker på att du vill ta bort denna variant? Åtgärden kan inte ångras.",
    "dialogDesc": "Konfigurera variantens namn, prissättning och dagsspecifika tider.",
    "namePlaceholder": "t.ex. Premiumpaket",
    "nameRequired": "Variantens namn krävs",
    "cost": "Kostnad",
    "award": "Ersättning",
    "currency": "Valuta",
    "days": "Dagar",
    "totalDuration": "Total tid",
    "scheduleDays": "Schemalägg dagar",
    "empty": "Inga varianter konfigurerade för denna tjänst.",
    "addFirst": "Lägg till din första variant",
    "added": "Variant tillagd",
    "updated": "Variant uppdaterad",
    "deleted": "Variant borttagen"
  },
  "qualifications": {
    "title": "Kvalifikationer",
    "global": "Globala",
    "local": "Butiksspecifika",
    "searchPlaceholder": "Sök kvalifikationer...",
    "addQualification": "Lägg till kvalifikation",
    "addQualificationDesc": "Skapa en ny kvalifikation för din organisation",
    "empty": "Inga kvalifikationer hittades",
    "level": "Nivå",
    "validity": "Giltighet",
    "months": "månader",
    "store": "Butik",
    "created": "Kvalifikation skapad",
    "updated": "Kvalifikation uppdaterad",
    "deleted": "Kvalifikation borttagen",
    "deleteConfirmTitle": "Ta bort kvalifikation",
    "deleteConfirmDesc": "Denna åtgärd kan inte ångras. Kvalifikationen kommer att tas bort permanent.",
    "levels": {
      "basic": "Grundläggande",
      "intermediate": "Medel",
      "advanced": "Avancerad",
      "expert": "Expert"
    },
    "form": {
      "basicInfo": "Grundläggande information",
      "basicInfoDesc": "Namn och beskrivning av kvalifikationen",
      "scopeLevel": "Omfattning & Nivå",
      "type": "Typ",
      "typeDesc": "Global gäller alla butiker, Lokal är butiksspecifik",
      "selectStore": "Välj en butik",
      "validityDesc": "Hur länge denna kvalifikation är giltig (i månader)",
      "additional": "Krav & Status",
      "requirements": "Krav",
      "requirementsPlaceholder": "t.ex. Måste genomföra 40h praktisk utbildning...",
      "requirementsDesc": "Förkunskaper eller utbildning som krävs",
      "activeDesc": "Aktiva kvalifikationer kan tilldelas personal och tjänster",
      "namePlaceholder": "t.ex. Certifierad bromsspecialist",
      "descriptionPlaceholder": "t.ex. Certifiering för bromssysteminspektion och reparation",
      "nameRequired": "Namn krävs",
      "storeRequiredForLocal": "Butik krävs för lokala kvalifikationer"
    },
    "serviceMapping": {
      "title": "Nödvändiga kvalifikationer",
      "description": "Välj kvalifikationer som krävs för att utföra denna tjänst",
      "noQualifications": "Inga kvalifikationer tilldelade",
      "addQualification": "Lägg till kvalifikation",
      "selectQualification": "Välj en kvalifikation"
    }
  },
  "timesheets": {
    "title": "Tidrapporter",
    "description": "Godkännanden, löneunderlag och närvaro",
    "subTabs": {
      "approvals": "Godkännanden",
      "salaryBasis": "Löneunderlag",
      "attendanceControl": "Närvarokontroll"
    },
    "createReport": "Skapa rapport",
    "newTimesheet": "Ny tidrapport",
    "type": "Typ",
    "office": "Kontor",
    "allOffices": "Alla kontor",
    "allStatus": "Alla statusar",
    "hours": "Timmar",
    "mileage": "Körsträcka",
    "amount": "Belopp",
    "status": {
      "draft": "Utkast",
      "submitted": "Inskickad",
      "approved": "Godkänd",
      "returned": "Returnerad",
      "paid": "Betald"
    },
    "types": {
      "timesheet": "Tidrapport",
      "outlay": "Utlägg"
    },
    "search": "Sök anställd...",
    "empty": "Inga tidrapporter hittades",
    "editor": {
      "back": "Tillbaka",
      "saveDraft": "Spara utkast",
      "submitReport": "Skicka in",
      "fieldWorkReport": "Fältarbetsrapport",
      "flexTime": "Flextid",
      "day": "Dag",
      "start": "Start",
      "end": "Slut",
      "break": "Rast",
      "worked": "Arbetat",
      "allocated": "Allokerat",
      "diff": "Diff",
      "note": "Anteckning",
      "dailyNote": "Daglig anteckning...",
      "weekend": "Helg",
      "checkIns": "Incheckningar",
      "jobs": "jobb",
      "distribute": "Fördela",
      "addAllocation": "+ Allokering",
      "addMileage": "Körsträcka",
      "progress": "Förlopp",
      "draftStep": "Utkast",
      "submittedStep": "Inskickad",
      "managerReview": "Chefsgranskning",
      "payrollProcessed": "Lön bearbetad",
      "livePayroll": "Live löneöversikt",
      "regularHours": "Ordinarie timmar",
      "unallocated": "Ej allokerat (Admin/Resa)",
      "workingDays": "Arbetsdagar",
      "baseSalary": "Grundlön",
      "commission": "Provision",
      "grossTotal": "Bruttototal",
      "rateBreakdown": "{{rate}} × {{hours}}h + Körsträcka",
      "comments": "Kommentarer",
      "noComments": "Inga kommentarer ännu.",
      "addComment": "Lägg till kommentar...",
      "submittedToast": "Tidrapport inskickad",
      "draftSaved": "Utkast sparat",
      "salesReport": "Säljrapport",
      "officeReport": "Kontorsrapport",
      "mileage": "Miltal",
      "clickToEdit": "Klicka för att redigera",
      "overrideWithWork": "— Åsidosätt med arbete"
    }
  },
  "reviews": {
    "title": "Recensioner & Betyg",
    "subtitle": "Visa och hantera kundfeedback på avslutade jobb",
    "avgRating": "Snittbetyg",
    "totalReviews": "Totalt recensioner",
    "recommendRate": "Rekommenderar",
    "flagged": "Flaggade",
    "ratingDistribution": "Betygsfördelning",
    "searchPlaceholder": "Sök recensioner...",
    "filterStatus": "Status",
    "filterRating": "Betyg",
    "published": "Publicerad",
    "pending": "Väntande",
    "flaggedStatus": "Flaggad",
    "stars": "Stjärnor",
    "noReviews": "Inga recensioner hittades",
    "quality": "Kvalitet",
    "service": "Service",
    "value": "Värde",
    "wouldRecommend": "Skulle rekommendera",
    "wouldNotRecommend": "Skulle inte rekommendera",
    "yourResponse": "Ditt svar",
    "submittedOn": "Inskickad den",
    "submit": {
      "title": "Hur var din upplevelse?",
      "subtitle": "Din feedback hjälper oss att förbättra vår service",
      "forJob": "För jobb",
      "overallExperience": "Övergripande upplevelse",
      "overallDesc": "Hur skulle du betygsätta din övergripande upplevelse?",
      "overallRating": "Övergripande betyg",
      "detailedRatings": "Detaljerade betyg",
      "writtenReview": "Din recension",
      "reviewTitle": "Recensionstitel",
      "reviewTitlePlaceholder": "Sammanfatta din upplevelse",
      "reviewComment": "Dina kommentarer",
      "reviewCommentPlaceholder": "Berätta mer om din upplevelse...",
      "wouldRecommend": "Skulle du rekommendera oss till andra?",
      "yourDetails": "Dina uppgifter",
      "yourName": "Ditt namn",
      "yourEmail": "E-postadress",
      "submitReview": "Skicka recension",
      "successTitle": "Recension inskickad!",
      "successDesc": "Tack för din feedback.",
      "thankYou": "Tack!",
      "thankYouDesc": "Din recension har skickats in. Vi uppskattar din feedback!"
    }
  },
  "myWork": {
    "title": "Min arbetsyta",
    "description": "Spåra ditt arbete, ledigheter och övertid",
    "logWork": "Logga arbete",
    "logWorkDesc": "Registrera dina arbetstimmar för en dag",
    "applyLeave": "Ansök om ledighet",
    "applyLeaveDesc": "Skicka in en ledighetsansökan för godkännande",
    "submitRequest": "Skicka ansökan",
    "leaveApplied": "Ledighetsansökan skickad",
    "workLogged": "Arbetslogg registrerad",
    "monthHours": "Månadstimmar",
    "overtimeHours": "Övertid",
    "presentDays": "Närvarande dagar",
    "leavesTaken": "Lediga dagar",
    "pendingRequests": "Väntande",
    "avgHours": "Snitt timmar",
    "perDay": "per dag",
    "thisMonth": "Denna månad",
    "overview": "Översikt",
    "calendar": "Kalender",
    "leavesDashboard": "Ledigheter",
    "timesheet": "Tidrapport",
    "overtimeLog": "Övertid",
    "todayStatus": "Dagens status",
    "notClockedIn": "Inte instämplad ännu",
    "leaveBalance": "Ledighetssaldo",
    "used": "använt",
    "total": "totalt",
    "remaining": "kvar",
    "recentActivity": "Senaste aktivitet",
    "present": "Närvarande",
    "leave": "Ledig",
    "halfDay": "Halvdag",
    "overtimeDay": "Övertid",
    "absent": "Frånvarande",
    "selectDay": "Dagdetaljer",
    "clickDayToView": "Klicka på en dag i kalendern för att visa detaljer",
    "leaveHistory": "Ledighetshistorik",
    "appliedOn": "Ansökt",
    "by": "Av",
    "totalOvertime": "Total övertid",
    "overtimeDays": "ÖT-dagar",
    "daysWithOT": "dagar med övertid",
    "avgOvertime": "Snitt ÖT",
    "perOvertimeDay": "per övertidsdag",
    "overtimeHistory": "Övertidshistorik",
    "weeklyTrend": "Timtrend (senaste 14 arbetsdagarna)",
    "monthlyGoal": "Månadsmål",
    "goalSubtitle": "Mål: 160 timmar / månad"
  },
  "teamView": {
    "title": "Teamöversikt",
    "description": "Övervaka teamets prestation, närvaro och ledighetshantering",
    "teamStatus": "Teamstatus",
    "leaveApprovals": "Ledighetsgodkännanden",
    "attendance": "Närvaro",
    "totalTeam": "Totalt team",
    "pendingLeaves": "Väntande ledigheter",
    "pendingApprovals": "Väntande godkännanden",
    "awaitingApproval": "väntar på godkännande",
    "searchEmployee": "Sök anställd...",
    "noEmployees": "Inga anställda hittades",
    "weekHours": "Vecktimmar",
    "leavesUsed": "Ledigheter använda",
    "today": "Idag",
    "week": "Vecka",
    "month": "Månad",
    "approve": "Godkänn",
    "reject": "Avslå",
    "approveLeave": "Godkänn ledighetsansökan",
    "rejectLeave": "Avslå ledighetsansökan",
    "rejectReason": "Anledning till avslag",
    "rejectReasonPlaceholder": "Ange en anledning till att avslå denna ledighetsansökan...",
    "confirmApprove": "Bekräfta godkännande",
    "confirmReject": "Bekräfta avslag",
    "leaveApproved": "Ledighetsansökan godkänd",
    "leaveRejected": "Ledighetsansökan avslagen",
    "noLeaveRequests": "Inga ledighetsansökningar",
    "workloadDistribution": "Arbetsbelastning (idag)",
    "topPerformers": "Topprestanda"
  },
  "myWorkspace": {
    "tabs": {
      "overview": "Översikt",
      "leaves": "Ledigheter",
      "timesheet": "Min tidrapport",
      "overtime": "Övertid",
      "salaries": "Löner"
    },
    "salarySlip": {
      "title": "Lönebesked",
      "payPeriod": "Löneperiod",
      "employeeName": "Anställds namn",
      "employeeEmail": "Anställds e-post",
      "employeeId": "Anställd-ID",
      "payDate": "Löneutbetalningsdatum",
      "earnings": "Intäkter",
      "baseSalary": "Grundlön",
      "hra": "Boendetillägg",
      "allowances": "Tillägg",
      "bonus": "Bonus",
      "gross": "Brutto",
      "deductions": "Avdrag",
      "incomeTax": "Inkomstskatt",
      "pension": "Pension",
      "insurance": "Försäkring",
      "total": "Totalt",
      "netPay": "Nettolön",
      "disclaimer": "Detta är ett datorgenererat lönebesked och kräver ingen signatur.",
      "downloaded": "Lönebesked nedladdat",
      "exportFailed": "Det gick inte att exportera PDF",
      "months": {
        "jan": "Januari",
        "feb": "Februari",
        "mar": "Mars",
        "apr": "April",
        "may": "Maj",
        "jun": "Juni",
        "jul": "Juli",
        "aug": "Augusti",
        "sep": "September",
        "oct": "Oktober",
        "nov": "November",
        "dec": "December"
      }
    }
  },
  "teamHub": {
    "tabs": {
      "team": "Teamstatus",
      "approvals": "Godkännanden",
      "calendar": "Teamkalender"
    },
    "calendar": {
      "title": "Teamkalender",
      "description": "Arbetstider, semester, sjukfrånvaro och annan frånvaro för hela teamet"
    }
  },
  "packages": {
    "title": "Paket",
    "description": "Kombinera tjänster och produkter till säljbara paket med varianter",
    "addPackage": "Nytt paket",
    "addPackageDesc": "Skapa ett nytt paket med varianter, tjänster och produkter",
    "searchPlaceholder": "Sök paket...",
    "empty": "Inga paket hittades",
    "notFound": "Paketet hittades inte",
    "created": "Paket skapat",
    "updated": "Paket uppdaterat",
    "validity": "Giltighet",
    "fromDate": "Giltig från",
    "toDate": "Giltig till",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "archived": "Arkiverad"
    },
    "form": {
      "basicInfo": "Grundinformation",
      "basicInfoDesc": "Allmänna uppgifter om detta paket",
      "namePlaceholder": "t.ex. Grundläggande servicepaket",
      "descriptionPlaceholder": "Vad ingår och vem är det för"
    },
    "variants": {
      "title": "Varianter",
      "desc": "Varje variant har ett pris, en tid och en uppsättning tjänster/produkter",
      "add": "Lägg till variant",
      "empty": "Inga varianter än. Lägg till en för att ange pris.",
      "namePlaceholder": "t.ex. Bensin / Diesel / Liten",
      "price": "Pris",
      "currency": "Valuta",
      "duration": "Tid (min)",
      "sortOrder": "Sortering",
      "remove": "Ta bort variant"
    },
    "services": {
      "title": "Tjänster",
      "add": "Lägg till tjänst",
      "empty": "Inga tjänster i denna variant",
      "selectVariant": "Välj variant",
      "noVariant": "Inga varianter",
      "selectService": "Välj tjänst",
      "remove": "Ta bort tjänst"
    },
    "products": {
      "title": "Produkter",
      "add": "Lägg till produkt",
      "empty": "Inga produkter i denna variant",
      "selectProduct": "Välj produkt",
      "remove": "Ta bort produkt"
    }
  },
  "absenceTypes": {
    "title": "Frånvarotyper",
    "description": "Definiera typer av frånvaro som anställda kan begära",
    "add": "Ny frånvarotyp",
    "addDesc": "Skapa en ny typ av frånvaro för din organisation",
    "searchPlaceholder": "Sök frånvarotyper...",
    "empty": "Inga frånvarotyper hittades",
    "notFound": "Frånvarotypen hittades inte",
    "created": "Frånvarotyp skapad",
    "updated": "Frånvarotyp uppdaterad",
    "deleted": "Frånvarotyp borttagen",
    "deleteConfirmTitle": "Ta bort frånvarotyp?",
    "deleteConfirmDesc": "Denna åtgärd kan inte ångras. Frånvarotypen kommer att raderas permanent.",
    "code": "Kod",
    "requiresApproval": "Kräver godkännande",
    "requiresDocumentation": "Kräver dokumentation",
    "isPaid": "Betald frånvaro",
    "allowPartialDay": "Tillåt del av dag",
    "advanceNoticeDays": "Förhandsbesked (dagar)",
    "annualLimitDays": "Årsgräns (dagar)",
    "colorCode": "Färgkod",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "draft": "Utkast",
      "terminated": "Avslutad"
    },
    "form": {
      "basicInfo": "Grundinformation",
      "basicInfoDesc": "Allmänna uppgifter om denna frånvarotyp",
      "rules": "Regler och konfiguration",
      "rulesDesc": "Definiera regler för godkännande, dokumentation och ersättning",
      "limits": "Gränser",
      "limitsDesc": "Ange frister och årsliga dagsgränser",
      "namePlaceholder": "t.ex. Semester",
      "codePlaceholder": "t.ex. SEM",
      "descriptionPlaceholder": "Beskriv denna frånvarotyp",
      "colorCodePlaceholder": "#000000",
      "annualLimitNone": "Ingen gräns"
    }
  },
  "unionAgreements": {
    "title": "Kollektivavtal",
    "description": "Hantera kollektiva avtal som gäller för anställda.",
    "add": "Nytt avtal",
    "addDesc": "Definiera ett nytt kollektivavtal och dess villkor.",
    "created": "Kollektivavtal skapat",
    "updated": "Kollektivavtal uppdaterat",
    "deleted": "Avtal borttaget",
    "empty": "Inga kollektivavtal ännu.",
    "searchPlaceholder": "Sök avtal…",
    "deleteConfirmTitle": "Ta bort avtal?",
    "deleteConfirmDesc": "Åtgärden kan inte ångras. Kollektivavtalet tas bort permanent.",
    "validity": "Giltighet",
    "startAt": "Startdatum",
    "endAt": "Slutdatum",
    "days": "dagar",
    "vacationDays": "Semesterdagar",
    "hoursPerWeek": "Timmar / vecka",
    "hourlyRate": "Timlön",
    "hourlyRatePlaceholder": "t.ex. 250",
    "limitationPeriod": "Begränsningsperiod",
    "limitationPeriodDesc": "Tillämpa lagstadgad begränsningsperiod.",
    "dayRest": "Dygnsvila (timmar)",
    "weekRest": "Veckovila (timmar)",
    "onCallTime": "Beredskapstid (timmar)",
    "sickDays": "Sjukdagar",
    "sickHours": "Sjuktimmar",
    "maxMonthlyOverTime": "Max övertid per månad (timmar)",
    "maxFourWeekOvertime": "Max övertid per 4 veckor (timmar)",
    "maxAnnulOverTime": "Max övertid per år (timmar)",
    "maxAnnualExceptionalOverTime": "Max extraordinär övertid per år (timmar)",
    "status": {
      "Active": "Aktiv",
      "Inactive": "Inaktiv",
      "Blacklisted": "Svartlistad"
    },
    "form": {
      "basicInfo": "Grundläggande information",
      "basicInfoDesc": "Identifiering och giltighet för kollektivavtalet.",
      "namePlaceholder": "t.ex. Metall Verkstadsavtal 2024",
      "workingTime": "Arbetstid",
      "workingTimeDesc": "Standardtimmar, semester och viloperioder.",
      "sickLeave": "Sjukledighet",
      "overtime": "Övertidsgränser",
      "overtimeDesc": "Maximal övertid tillåten under olika perioder.",
      "nameRequired": "Namn krävs",
      "startAtRequired": "Startdatum krävs",
      "endAtRequired": "Slutdatum krävs"
    }
  },
  "overtime": {
    "created": "Övertid registrerad",
    "register": {
      "title": "Registrera övertid",
      "date": "Datum",
      "timeRange": "Tidsintervall",
      "commentPlaceholder": "Valfri anteckning...",
      "submit": "Registrera övertid"
    }
  },
  "staffAttendance": {
    "registerAbsence": "Registrera frånvaro",
    "registerOvertime": "Registrera övertid",
    "searchEmployee": "Sök anställd...",
    "editedShift": "Redigerat pass",
    "hours": "Timmar",
    "editShift": "Redigera pass",
    "break": "Rast (min)",
    "repeat": "Upprepa",
    "doesNotRepeat": "Upprepas inte",
    "weekly": "Varje vecka",
    "shiftSaved": "Pass sparat",
    "noEmployees": "Inga anställda hittades"
  },
  "changePassword": {
    "subtitle": "Uppdatera ditt lösenord för att hålla ditt konto säkert",
    "passwordSecurity": "Lösenordssäkerhet",
    "changePasswordTitle": "Ändra lösenord",
    "chooseStrong": "Välj ett starkt lösenord som du inte använder någon annanstans",
    "currentPassword": "Nuvarande lösenord",
    "currentPasswordPlaceholder": "Ange nuvarande lösenord",
    "newPasswordPlaceholder": "Ange nytt lösenord",
    "requirementsTitle": "Lösenordskrav:",
    "req8Chars": "Minst 8 tecken",
    "reqUppercase": "Innehåller en stor bokstav",
    "reqLowercase": "Innehåller en liten bokstav",
    "reqNumber": "Innehåller en siffra",
    "reqSpecial": "Innehåller ett specialtecken",
    "confirmNewPassword": "Bekräfta nytt lösenord",
    "confirmNewPasswordPlaceholder": "Bekräfta nytt lösenord",
    "passwordsDoNotMatch": "Lösenorden matchar inte",
    "newPasswordsMismatchToast": "De nya lösenorden matchar inte",
    "meetRequirementsToast": "Uppfyll alla lösenordskrav",
    "updateSuccessToast": "Lösenordet har ändrats",
    "updatePassword": "Uppdatera lösenord"
  },
  "account": {
    "tabs": {
      "profile": "Profil",
      "workingHours": "Arbetstider",
      "security": "Säkerhet",
      "loginHistory": "Inloggningshistorik"
    },
    "profilePicture": "Profilbild",
    "updateProfilePhoto": "Uppdatera din profilbild",
    "uploadPhoto": "Ladda upp bild",
    "photoHint": "JPG, GIF eller PNG. Max 2 MB.",
    "personalInformation": "Personlig information",
    "updatePersonalDetails": "Uppdatera dina personuppgifter",
    "emailAddress": "E-postadress",
    "phoneNumber": "Telefonnummer",
    "companyName": "Företagsnamn",
    "addressTitle": "Adress",
    "addressDesc": "Din företags- eller privatadress",
    "streetAddress": "Gatuadress",
    "city": "Ort",
    "state": "Län",
    "zip": "Postnummer",
    "saveChanges": "Spara ändringar",
    "profileUpdatedToast": "Profilen har uppdaterats",
    "changesDiscardedToast": "Ändringar förkastade",
    "regularWorkingHours": "Ordinarie arbetstider",
    "workingHoursDesc": "Ange ditt normala veckoschema. Lämna tider tomma för lediga dagar.",
    "day": "Dag",
    "startTime": "Starttid",
    "endTime": "Sluttid",
    "restTime": "Rast (tt:mm)",
    "twoFactorAuth": "Tvåfaktorsautentisering",
    "twoFactorDesc": "Lägg till ett extra säkerhetslager till ditt konto",
    "authenticatorApp": "Autentiseringsapp",
    "authenticatorDesc": "Använd en autentiseringsapp för att generera engångskoder",
    "enable": "Aktivera",
    "dangerZone": "Farozon",
    "dangerZoneDesc": "Oåterkalleliga och destruktiva åtgärder",
    "deleteAccount": "Ta bort konto",
    "deleteAccountDesc": "Ta bort ditt konto och all tillhörande data permanent. Detta kan inte ångras.",
    "deleteConfirmTitle": "Är du helt säker?",
    "deleteConfirmDesc": "Denna åtgärd kan inte ångras. Detta kommer permanent ta bort ditt konto och all din data från våra servrar.",
    "deleteConfirmAction": "Ja, ta bort mitt konto",
    "deletionSubmittedToast": "Begäran om kontoborttagning har skickats",
    "loginHistoryTitle": "Inloggningshistorik",
    "loginHistoryDesc": "Senaste inloggningsaktivitet på ditt konto"
  },
  "economy": {
    "title": "Ekonomi",
    "description": "Fakturor, betalningar och löner",
    "sync": "Synka",
    "syncedToast": "Synkroniserad med bokföring",
    "exportStartedToast": "Export startad",
    "drafts": "Utkast",
    "totalDraftValue": "Totalt utkastvärde",
    "avgDraftValue": "Genomsnittligt utkastvärde",
    "invoicesTab": "Fakturor",
    "paymentsTab": "Betalningar",
    "timeReportsTab": "Tidrapporter",
    "searchPlaceholder": "Sök efter jobb-ID, kund, fordon...",
    "noDrafts": "Inga utkast",
    "noInvoices": "Inga fakturor",
    "noPayments": "Inga betalningar",
    "noReports": "Inga rapporter",
    "columns": {
      "jobId": "Jobb-ID",
      "customer": "Kund",
      "vehicle": "Fordon",
      "services": "Tjänster",
      "parts": "Delar",
      "labor": "Arbete",
      "total": "Totalt",
      "status": "Status",
      "invoiceNumber": "Faktura #",
      "amount": "Belopp",
      "dueDate": "Förfallodatum",
      "reference": "Referens",
      "method": "Metod",
      "date": "Datum",
      "employee": "Anställd",
      "period": "Period",
      "hours": "Timmar",
      "overtime": "Övertid"
    },
    "draftBadge": "Utkast",
    "detail": {
      "draftTitle": "Utkast · {{id}}",
      "invoiceTitle": "Faktura · {{id}}",
      "paymentTitle": "Betalning · {{id}}",
      "timeReportTitle": "Tidrapport · {{id}}",
      "draftDesc": "Fakturautkast redo för granskning",
      "invoiceDesc": "Fakturadetaljer och betalningsstatus",
      "paymentDesc": "Detaljer om betalningstransaktion",
      "timeReportDesc": "Nedbrytning av anställds tidrapport",
      "regularHours": "Ordinarie timmar",
      "sendInvoice": "Skicka faktura",
      "sendInvoiceToast": "Utkast skickat som faktura",
      "editedToast": "Utkast redigerat",
      "sendReminder": "Skicka påminnelse",
      "reminderSentToast": "Påminnelse skickad",
      "pdf": "PDF",
      "downloadedToast": "Nedladdad",
      "sendReceipt": "Skicka kvitto",
      "receiptSentToast": "Kvitto skickat",
      "approve": "Godkänn",
      "approvedToast": "Godkänd",
      "reject": "Avslå",
      "rejectedToast": "Avslagen"
    }
  },
  "checkIn": {
    "atWorkNow": "På jobbet nu",
    "lateArrivals": "Sena ankomster",
    "missingPunches": "Saknade stämplingar",
    "allStatus": "Alla status",
    "statusIn": "In",
    "statusOut": "Ut",
    "allTypes": "Alla typer",
    "typeLive": "Live",
    "typeManual": "Manuell",
    "typeAdjusted": "Justerad",
    "employee": "Anställd",
    "sessions": "Pass",
    "totalHours": "Totala timmar",
    "noEntriesFound": "Inga poster hittades",
    "sessionDeleted": "Pass borttaget",
    "attendanceSessions": "Närvaropass",
    "addMissingPunch": "Lägg till saknad stämpling",
    "session": "Pass {{n}}",
    "duration": "Varaktighet:",
    "notes": "Anteckningar",
    "notesPlaceholder": "Lägg till anteckningar om denna närvaropost...",
    "scheduled": "Schemalagd"
  },
  "teamApprovals": {
    "status": {
      "pending": "Väntande",
      "approved": "Godkänd",
      "rejected": "Avvisad",
      "onHold": "Pausad"
    },
    "allMonths": "Alla månader",
    "allStatuses": "Alla statusar",
    "grossTotal": "Bruttosumma",
    "month": "Månad",
    "regularHours": "Ordinarie timmar",
    "overtimeHours": "Övertidstimmar",
    "hourlyRate": "Timlön",
    "overtimeRate": "Övertidsersättning (×1,5)",
    "baseSalary": "Grundlön",
    "overtimePay": "Övertidsersättning",
    "commission": "Provision",
    "leavesTab": "Ledigheter",
    "timesheetsTab": "Tidrapporter",
    "noLeaveRequests": "Inga ledighetsansökningar",
    "noTimesheetSubmissions": "Inga inskickade tidrapporter",
    "appliedPrefix": "Ansökt",
    "daysSuffix": "dagar",
    "total": "Totalt",
    "regular": "Ordinarie",
    "otAbbr": "ÖT",
    "hold": "Pausa",
    "reject": "Avslå",
    "approve": "Godkänn",
    "noteLabel": "Anteckning:",
    "approveRequestTitle": "Godkänn förfrågan",
    "rejectRequestTitle": "Avslå förfrågan",
    "holdRequestTitle": "Pausa förfrågan",
    "reasonForRejection": "Anledning till avslag",
    "noteOptional": "Anteckning (valfritt)",
    "provideReasonPlaceholder": "Ange en anledning...",
    "whyOnHoldPlaceholder": "Varför pausas denna?",
    "confirmApproval": "Bekräfta godkännande",
    "confirmRejection": "Bekräfta avslag",
    "placeOnHold": "Pausa",
    "editing": "Redigerar",
    "timesheetTab": "Tidrapport",
    "salaryTab": "Lön",
    "leaveDetails": "Ledighetsdetaljer",
    "overtimeDetails": "Övertidsdetaljer",
    "period": "Period",
    "duration": "Varaktighet",
    "hours": "Timmar",
    "job": "Jobb",
    "appliedOn": "Ansökt den",
    "reasonSection": "Anledning",
    "managerNote": "Chefsanteckning",
    "employeeSection": "Anställd",
    "role": "Roll",
    "requestApprovedToast": "Förfrågan godkänd",
    "requestRejectedToast": "Förfrågan avslagen",
    "requestOnHoldToast": "Förfrågan pausad"
  }
}
